(() => {
  if (customElements.get('labels-search')) return;

  /* ============================================================
     Vocabulary — English, Dutch, German
     ============================================================ */
  const CATS = {
    boots:     { label: 'Boots',     stems: ['boot', 'laars', 'laarz', 'stiefel', 'botte', 'stival'], words: 'boot boots laars laarzen stiefel stiefeln enkellaarzen chelsea bottes botte stivali stivale botas bota' },
    sneakers:  { label: 'Sneakers',  stems: ['sneaker', 'trainer', 'runner'], words: 'sneaker sneakers trainers runner runners turnschuhe baskets zapatillas' },
    shoes:     { label: 'Shoes',     stems: ['boot', 'sneaker', 'shoe', 'loafer', 'derby', 'sandal', 'mule', 'pump', 'trainer', 'schoen', 'schuh', 'chaussure', 'scarpe', 'zapato'], words: 'shoe shoes schoen schoenen schuhe footwear chaussures chaussure scarpe zapato zapatos' },
    loafers:   { label: 'Loafers',   stems: ['loafer', 'derby', 'mocassin', 'moccasin'], words: 'loafer loafers derby derbies instappers mocassini mocasines' },
    sandals:   { label: 'Sandals',   stems: ['sandal', 'slide', 'mule', 'sandale', 'sandali'], words: 'sandal sandals slides mules sandalen sandales sandali sandalias' },
    coat:      { label: 'Coats',     stems: ['coat', 'trench', 'parka', 'mantel', 'jas', 'manteau', 'cappott', 'abrigo'], words: 'coat coats overcoat trench parka mantel mantels jassen manteaux manteau cappotti cappotto abrigos abrigo' },
    jacket:    { label: 'Jackets',   stems: ['jacket', 'blazer', 'bomber', 'jacke', 'jasje', 'biker', 'veste', 'giacca', 'chaqueta'], words: 'jacket jackets blazer blazers bomber biker jacke jacken jasje jacks vestes veste giacche giacca chaquetas chaqueta' },
    outerwear: { label: 'Outerwear', stems: ['coat', 'jacket', 'parka', 'trench', 'blazer', 'bomber', 'jas', 'jacke', 'mantel'], words: 'jas outerwear capispalla' },
    knit:      { label: 'Knitwear',  stems: ['sweater', 'jumper', 'knit', 'hoodie', 'cardigan', 'pullover', 'sweatshirt', 'trui', 'strick'], words: 'sweater sweaters jumper jumpers hoodie hoodies knit knitwear trui truien pullover cardigan cardigans sweatshirt strick breigoed maille maglieria maglia punto' },
    tops:      { label: 'Tops',      stems: ['t-shirt', 'tshirt', 'tee', 'shirt', 'top', 'polo', 'blouse', 'hemd', 'bluse'], words: 't-shirt tshirt tee tees shirt shirts top tops polo blouse blouses overhemd hemd bluse hauts haut oberteile' },
    trousers:  { label: 'Trousers',  stems: ['trouser', 'pant', 'jean', 'denim', 'cargo', 'broek', 'hose', 'pantalon'], words: 'trousers pants jeans denim broek broeken hose hosen cargo cargos pantalons pantalon pantaloni pantalones' },
    shorts:    { label: 'Shorts',    stems: ['short'], words: 'shorts short' },
    skirt:     { label: 'Skirts',    stems: ['skirt', 'rok', 'rock'], words: 'skirt skirts rok rokken rock rocke jupes jupe gonne gonna faldas falda' },
    dress:     { label: 'Dresses',   stems: ['dress', 'jurk', 'kleid', 'gown', 'abito', 'vestido'], words: 'dress dresses jurk jurken kleid kleider gown robes robe abiti abito vestidos vestido' },
    bags:      { label: 'Bags',      stems: ['bag', 'tote', 'clutch', 'pouch', 'tas', 'tasche', 'backpack', 'borsa', 'bolso'], words: 'bag bags tas tassen tasche taschen clutch clutches tote totes handbag backpack sacs sac borse borsa bolsos bolso' },
    accessories: { label: 'Accessories', stems: ['belt', 'wallet', 'scarf', 'hat', 'cap', 'glove', 'jewel', 'ring', 'necklace', 'sunglass'], words: 'accessories accessoires belt belts riem wallet scarf sjaal hat cap caps pet gloves jewellery jewelry sieraden sunglasses accessori accesorios' }
  };
  const COLORS = {
    black: 'black zwart zwarte schwarz schwarze schwarzen noir noire noires nero nera neri negro negra', white: 'white wit witte weiss weisse ivory offwhite off-white ecru blanc blanche bianco bianca blanco blanca',
    grey: 'grey gray grijs grijze grau graue charcoal antraciet gris grigio grise', brown: 'brown bruin bruine braun braune chocolate marron marrone',
    beige: 'beige camel tan sand taupe', red: 'red rood rode rot rote burgundy bordeaux rouge rosso rojo', yellow: 'yellow geel gele gelb jaune giallo amarillo',
    blue: 'blue blauw blauwe blau navy indigo bleu bleue blu azul', green: 'green groen groene grun grune olive khaki vert verte verde', pink: 'pink roze rosa fuchsia rose', purple: 'purple paars paarse lila lilac violet violette viola violeta', orange: 'orange oranje naranja arancione',
    silver: 'silver zilver silber silberne argent argento plata', gold: 'gold goud goldene dore oro'
  };
  const DEPTS = { m: 'men mens man heren herren male him homme menswear uomo hombre', w: 'women womens woman dames damen female her femme ladies womenswear donna mujer' };
  const FLAGS = { sale: 'sale korting reduziert outlet discount discounted afgeprijsd soldes solde saldo rebajas oferta sconto', newOnly: 'new nieuw nieuwe neu neue latest nouveau nouvelle nouveaux nuovo nuova nuevo nueva novedades novita', cheap: 'cheap cheapest goedkoop goedkope gunstig budget affordable' };
  const OCCASIONS = {
    gallery: ['gallery galerie opening vernissage museum art exhibition exposition mostra exposicion', 'Gallery, ', 'after dark.'],
    wedding: ['wedding bruiloft hochzeit ceremony mariage matrimonio boda', 'The wedding ', 'guest.'],
    dinner: ['dinner diner etentje abendessen restaurant cena', 'Dinner, ', 'then late.'],
    office: ['office work kantoor werk buro business meeting bureau ufficio oficina', 'Monday, ', 'sharpened.'],
    party: ['party feest feestje club clubbing nightclub fete fiesta festa', 'After ', 'midnight.'],
    date: ['date', 'First date, ', 'quietly.'],
    festival: ['festival', 'Field ', 'days.'],
    weekend: ['weekend casual sunday saturday', 'Slow ', 'Saturday.'],
    travel: ['travel reis reise trip airport flight vacation vakantie urlaub voyage viaggio viaje', 'Carry-on ', 'only.']
  };
  const LOOKWORDS = 'look looks outfit outfits style styled styling stylen wear wearing aantrekken anziehen combine combineer kombinieren';
  const STOP = new Set('a an the for in of on to and or with my me i want need looking something some show find zoek ik wil een het de en met voor op im und der die das ein eine mit fur ich suche bitte please any all piece pieces item items from van te om by von par di du des nel nella sous pour con per para auf sur les las los gli le la il da'.split(' '));
  const vocab = (map, pick) => { const o = {}; Object.entries(map).forEach(([k, v]) => pick(v).split(' ').forEach((w) => (o[w] = k))); return o; };
  const W_CAT = vocab(CATS, (v) => v.words);
  const W_COLOR = vocab(COLORS, (v) => v);
  const W_DEPT = vocab(DEPTS, (v) => v);
  const W_FLAG = vocab(FLAGS, (v) => v);
  const W_OCC = vocab(OCCASIONS, (v) => v[0]);
  const W_LOOK = new Set(LOOKWORDS.split(' '));
  const RESERVED = new Set([...Object.keys(W_CAT), ...Object.keys(W_COLOR), ...Object.keys(W_DEPT), ...Object.keys(W_FLAG), ...Object.keys(W_OCC), ...W_LOOK, ...STOP]);

  /* ============================================================
     Helpers
     ============================================================ */
  const norm = (s) => String(s || '').toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[̀-ͯ]/g, '');
  const clean = (s) => norm(s).replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const escRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const num = (s) => parseInt(String(s).replace(/[.,]/g, ''), 10);
  const handleize = (s) => clean(s).replace(/ /g, '-');
  const uniq = (a) => [...new Set(a)];
  function lev(a, b) {
    const m = a.length, n = b.length; if (!m) return n; if (!n) return m;
    let prev = Array.from({ length: n + 1 }, (_, j) => j);
    for (let i = 1; i <= m; i++) {
      const cur = [i];
      for (let j = 1; j <= n; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = cur;
    }
    return prev[n];
  }
  const store = {
    get(k, d) { try { const v = localStorage.getItem('labels-search:' + k); return v ? JSON.parse(v) : d; } catch (_) { return d; } },
    set(k, v) { try { localStorage.setItem('labels-search:' + k, JSON.stringify(v)); } catch (_) {} }
  };
  const ICON_BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 8h14l-1 13H6L5 8z"/><path d="M9 8V6a3 3 0 016 0v2"/><path d="M12 12v5M9.5 14.5h5"/></svg>';
  const ICON_SWAP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 7h13l-3-3M20 17H7l3 3"/></svg>';
  const REFINE = { rm: 'remove', addword: 'add_word', nofuzzy: 'no_correction', nolook: 'no_look', sort: 'sort', lens: 'lens', tone: 'tone', swap: 'swap', dept: 'dept' };
  const SHOE_SIZES = ['35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47'];
  const CLOTH_SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  const SKU_RE = /^\s*(\d{5,7})(?:[-\/][^\s]{1,10})?\s*$/;
  const ONE_SIZE = /^(one ?size|os|osfa|tu|u|uni|unica|taglia unica|einheitsgrosse|onesize fits all)$/;
  const FOOTWEAR_STEMS = uniq([...CATS.shoes.stems, ...CATS.sandals.stems, ...CATS.loafers.stems, ...CATS.boots.stems, 'flat', 'heel', 'slipper', 'espadrille', 'clog', 'brogue']);

  /* ============================================================
     Element
     ============================================================ */
  class LabelsSearch extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      // A section reload in the theme editor leaves an old copy in <body>; remove it.
      document.querySelectorAll('labels-search').forEach((el) => { if (el !== this && el.id === this.id) el.remove(); });
      // Live directly under <body> so no sticky / transformed header can trap the fixed overlay.
      if (this.parentElement !== document.body) document.body.appendChild(this);
      this.init();
    }

    init() {
      const $ = (s) => this.querySelector(s);
      this.cfg = JSON.parse($('[data-ls-config]').textContent);
      this.sid = this.dataset.sid;
      this.el = {
        sheet: $('.ls-sheet'), q: $('[data-ls-q]'), ghost: $('[data-ls-ghost]'), form: $('[data-ls-form]'), body: $('[data-ls-body]'),
        chips: $('[data-ls-chips]'), dock: $('[data-ls-dock]'), suggest: $('[data-ls-suggest]'), suggestText: $('[data-ls-suggest-text]'),
        clear: $('[data-ls-clear]'), toast: $('[data-ls-toast]'), mail: $('[data-ls-mail]'), mailTitle: $('[data-ls-mail-title]'),
        mailText: $('[data-ls-mail-text]'), mailInput: $('[data-ls-mail-input]'), counts: [...this.querySelectorAll('[data-ls-count]')]
      };
      this.S = {
        removed: new Set(), noFuzzy: false, noLook: false, tone: null, lookIdx: {}, lensTab: 'new', sort: 'best', editProfile: false, active: -1, req: 0,
        profile: Object.assign({ dept: this.cfg.deptDefault || 'm', shoe: '', size: '' }, store.get('profile', {})),
        recent: store.get('recent', []), viewed: store.get('viewed', []), follows: store.get('follows', []), aff: store.get('aff', {}),
        email: this.cfg.email || store.get('email', '')
      };
      this.cache = new Map();
      this.items = new Map();
      this._sentQ = new Set();
      this.buildVendors();
      this.recordCurrent();
      this.recordCtx();
      this.bindLearning();
      this.bind();
      if (window.Shopify && window.Shopify.designMode) this.bindEditor();
    }

    /* ---------- Data from Liquid ---------- */
    buildVendors() {
      const vendors = (this.cfg.vendors || []).filter(Boolean);
      const al = vendors.map((v) => [clean(v), v]);
      const counts = {};
      const extra = [];
      vendors.forEach((v) => {
        const parts = clean(v).split(' ');
        if (parts.length < 2) return;
        uniq([parts[0], parts[parts.length - 1]]).forEach((w) => { if (w.length >= 4 && !RESERVED.has(w)) { counts[w] = (counts[w] || 0) + 1; extra.push([w, v]); } });
      });
      this.fullAliases = al.slice().sort((x, y) => y[0].length - x[0].length);
      this.partAliases = [];
      extra.forEach(([w, v]) => { if (counts[w] === 1 && !al.some(([a]) => a === w)) { al.push([w, v]); this.partAliases.push([w, v]); } });
      this.aliases = al.sort((x, y) => y[0].length - x[0].length);
      this.prefixAliases = al.slice().sort((x, y) => x[0].length - y[0].length);
      this.fuzzyAliases = al.filter(([a]) => a.length >= 4);
      this.similar = {};
      String(this.cfg.similar || '').split('\n').forEach((line) => {
        const [k, rest] = line.split(':');
        if (k && rest) this.similar[clean(k)] = rest.split(',').map((x) => x.trim()).filter(Boolean);
      });
      const tags = (s, d) => uniq((String(s || '') + ',' + d).split(',').map(clean).filter(Boolean));
      this.menTags = tags(this.cfg.menTags, 'men,mens,man,male,menswear,heren,herren');
      this.womenTags = tags(this.cfg.womenTags, 'women,womens,woman,female,womenswear,dames,damen,ladies');
    }

    buildNav() {
      if (this.nav) return;
      this.nav = []; this.dmap = new Map();
      const mm = document.getElementById('labels-mm');
      if (!mm) return;
      mm.querySelectorAll('[data-mm-trigger]').forEach((btn) => {
        const dept = btn.textContent.trim();
        const dk = W_DEPT[clean(dept)] || clean(dept);
        const panel = mm.querySelector('#' + CSS.escape(btn.getAttribute('aria-controls') || ''));
        if (!panel) return;
        panel.querySelectorAll('a[href]').forEach((a) => {
          const t = a.textContent.replace(/\s+/g, ' ').replace(/→/g, '').trim();
          if (!t) return;
          if (a.matches('.mm-chip, .mm-brandlist a, .mm-dlink, .mm-brand')) {
            const name = a.dataset.mmV || (a.matches('.mm-brand') ? a.firstElementChild?.textContent : t);
            const k = clean(name);
            if (!this.dmap.has(k)) this.dmap.set(k, []);
            if (!this.dmap.get(k).some((x) => x.dept === dept)) this.dmap.get(k).push({ dept, dk, url: a.href });
          } else if (a.matches('.mm-link, .mm-big, .mm-h a')) {
            this.nav.push({ dept, dk, t, n: clean(t), url: a.href });
          }
        });
      });
    }

    recordCurrent() {
      const el = this.querySelector('[data-ls-current]');
      if (!el) return;
      try {
        const it = JSON.parse(el.textContent);
        it.seen = Date.now();
        if (this.once('pv:' + it.id)) this.learnItem(it, 2);
        this.S.viewed = [it, ...this.S.viewed.filter((x) => x.id !== it.id)].slice(0, 12);
        store.set('viewed', this.S.viewed);
      } catch (_) {}
    }

    /* ---------- Personalisation (kept on this device only) ---------- */
    once(key) {
      let seen = false;
      try { seen = !!sessionStorage.getItem('labels-search:' + key); sessionStorage.setItem('labels-search:' + key, '1'); } catch (_) {}
      return !seen;
    }
    aff() {
      const a = this.S.aff || (this.S.aff = {});
      ['d', 'k', 'col', 'dept'].forEach((x) => { a[x] = a[x] || {}; });
      a.prices = a.prices || [];
      return a;
    }
    bump(kind, key, w) {
      if (!key || !w) return;
      const a = this.aff(), now = Date.now(), cur = a[kind][key];
      const decayed = cur ? cur[0] * Math.pow(0.5, (now - cur[1]) / (21 * 864e5)) : 0;
      a[kind][key] = [Math.min(decayed + w, 60), now];
      const keys = Object.keys(a[kind]);
      if (keys.length > 40) keys.sort((x, y) => a[kind][x][0] - a[kind][y][0]).slice(0, keys.length - 40).forEach((k) => delete a[kind][k]);
      this._norm = null;
      store.set('aff', a);
    }
    catKeyOf(it) {
      for (const k of ['boots', 'sneakers', 'loafers', 'sandals', 'coat', 'jacket', 'knit', 'tops', 'trousers', 'shorts', 'skirt', 'dress', 'bags', 'accessories']) if (this.catOk(it, CATS[k])) return k;
      return null;
    }
    colorOf(it) { return Object.keys(COLORS).find((c) => this.colorOk(it, c)) || null; }
    learnItem(it, w) {
      if (!it) return;
      this.prep(it);
      this.bump('d', it.v, w);
      this.bump('k', this.catKeyOf(it), w * 0.8);
      this.bump('col', this.colorOf(it), w * 0.5);
      if (it.dept) this.bump('dept', it.dept, w);
      if (it.p) { const a = this.aff(); a.prices = [it.p, ...a.prices].slice(0, 24); store.set('aff', a); }
    }
    learnIntent(p, w) {
      if (!p) return;
      if (p.designer) this.bump('d', p.designer, w * 1.3);
      if (p.catKey && CATS[p.catKey]) this.bump('k', p.catKey, w);
      if (p.color) this.bump('col', p.color, w * 0.8);
      if (p.dept) this.bump('dept', p.dept, w * 1.5);
    }
    norm() {
      if (this._norm) return this._norm;
      const a = this.aff(), now = Date.now(), out = {};
      ['d', 'k', 'col', 'dept'].forEach((kind) => {
        const raw = {}; let max = 0;
        Object.entries(a[kind]).forEach(([k, v]) => { const x = v[0] * Math.pow(0.5, (now - v[1]) / (21 * 864e5)); raw[k] = x; if (x > max) max = x; });
        const n = {}; Object.keys(raw).forEach((k) => { n[k] = max ? raw[k] / max : 0; });
        out[kind] = { raw, n, max };
      });
      const pr = a.prices.slice().sort((x, y) => x - y);
      out.price = pr.length >= 3 ? pr[Math.floor(pr.length / 2)] : 0;
      out.signal = out.d.max + out.k.max >= 3;
      return (this._norm = out);
    }
    top(kind, n, min) {
      return Object.entries(this.norm()[kind].raw).filter(([, v]) => v >= (min || 0)).sort((x, y) => y[1] - x[1]).slice(0, n).map((x) => x[0]);
    }
    affScore(it) {
      const N = this.norm();
      if (!N.signal) return 0;
      let sc = (N.d.n[it.v] || 0) * 0.55 + (N.k.n[this.catKeyOf(it)] || 0) * 0.3 + (N.col.n[this.colorOf(it)] || 0) * 0.15;
      if (N.price && it.p) { const r = it.p / N.price; if (r > 0.5 && r < 1.8) sc += 0.15; }
      return sc;
    }
    inferDept() {
      if (this.S.profile.deptSet) return;
      const d = this.norm().dept.raw, m = d.m || 0, w = d.w || 0;
      if (Math.max(m, w) >= 2 && Math.abs(m - w) > 1) this.S.profile.dept = m > w ? 'm' : 'w';
    }
    recordCtx() {
      const el = this.querySelector('[data-ls-ctx]');
      if (!el) return;
      let c; try { c = JSON.parse(el.textContent); } catch (_) { return; }
      if (!this.once('ctx:' + location.pathname + (c.q || ''))) return;
      if (c.t === 'c') {
        const vs = (c.vendors || []).filter(Boolean);
        if (vs.length === 1) this.bump('d', vs[0], 1.5);
        const words = clean(c.title).split(' ');
        const k = words.map((w) => W_CAT[w]).find(Boolean); if (k) this.bump('k', k, 1);
        const dp = words.map((w) => W_DEPT[w]).find(Boolean); if (dp) this.bump('dept', dp, 1);
      } else if (c.t === 's' && c.q) this.learnIntent(this.parse(c.q), 1);
    }
    bindLearning() {
      // Add to bag on the product page counts as the strongest signal.
      document.addEventListener('submit', (e) => {
        const f = e.target;
        if (!f || !f.action || !/\/cart\/add/.test(f.action) || this.contains(f)) return;
        const el = this.querySelector('[data-ls-current]');
        if (el) { try { this.learnItem(JSON.parse(el.textContent), 3); } catch (_) {} }
      }, true);
    }
    resetMe() {
      const S = this.S;
      S.aff = {}; S.recent = []; S.viewed = []; S.follows = [];
      S.profile = { dept: this.cfg.deptDefault || 'm', shoe: '', size: '', deptSet: false };
      S.editProfile = false; S.removed.clear();
      ['aff', 'recent', 'viewed', 'follows'].forEach((k) => store.set(k, k === 'aff' ? {} : []));
      store.set('profile', S.profile);
      this._norm = null; this._trends = null;
      this.toast(this.tf('reset_toast'));
      this.renderZero();
    }

    /* ---------- Real trends: best-selling + newest products, per department ---------- */
    trends() {
      const dept = this.S.profile.dept;
      if (this._trends && this._trends.dept === dept && this._trends.at === this.norm()) return Promise.resolve(this._trends);
      const du = (this.cfg.deptUrl || {})[dept];
      const cands = du ? [du] : (dept === 'w' ? ['womenswear', 'women', 'womens', 'dames'] : ['menswear', 'men', 'mens', 'heren']).map((h) => this.cfg.collectionsUrl + '/' + h);
      const pair = (base) => Promise.all([
        this.get(this.view(base, '&sort_by=best-selling', 'labels-trend')),
        this.get(this.view(base, '&sort_by=created-descending', 'labels-trend'))
      ]);
      // Department collection first (set in the block, else /collections/men or /collections/women), then the whole shop.
      let scoped = false;
      const tryNext = (i) => (i >= cands.length ? Promise.resolve([null, null]) : pair(cands[i]).then((r) => (((r[0] && r[0].items.length) || (r[1] && r[1].items.length)) ? r : tryNext(i + 1))));
      return tryNext(0).then((r) => {
        if ((r[0] && r[0].items.length) || (r[1] && r[1].items.length)) { scoped = true; [r[0], r[1]].forEach((l) => ((l && l.items) || []).forEach((it) => { if (!it.dept) it.dept = dept; })); return r; }
        return pair(this.cfg.trendUrl);
      }).then(([best, fresh]) => {
        if (!best && !fresh) { this._trendsNull = true; return null; }
        const D = {}, K = {};
        const add = (list, w0) => ((list && list.items) || []).forEach((it, i) => {
          if (!it.a || (!scoped && it.dept && it.dept !== dept)) return;
          const w = w0 / (1 + i / 12);
          D[it.v] = (D[it.v] || 0) + w;
          const k = this.catKeyOf(it); if (k) K[k] = (K[k] || 0) + w;
        });
        add(best, 1); add(fresh, 0.45);
        const N = this.norm();
        const boost = (m, nm) => Object.entries(m).map(([k, v]) => [k, v * (1 + 1.2 * (nm[k] || 0))]).sort((x, y) => y[1] - x[1]);
        const seen = new Set(this.S.viewed.map((v) => String(v.id)));
        const pool = ((best && best.items) || []).filter((it) => it.a && !seen.has(String(it.id)) && (scoped || !it.dept || it.dept === dept));
        // Suggestions for shoppers without history, built from what actually sells right now.
        const ideas = (() => {
          const live = pool.length ? pool : ((best && best.items) || []).filter((it) => it.a);
          if (!live.length) return [];
          const by = (list, f) => { const m = {}; list.forEach((it) => { const k = f(it); if (k) m[k] = (m[k] || 0) + 1; }); return Object.entries(m).sort((x, y) => y[1] - x[1]).map((x) => x[0]); };
          const des = by(live, (it) => it.v);
          const freshDes = by(((fresh && fresh.items) || []).filter((it) => it.a && (scoped || !it.dept || it.dept === dept)), (it) => it.v);
          const cats = by(live, (it) => this.catKeyOf(it)).filter((k) => CATS[k]);
          const itemOf = (col, k) => {
            const cat = this.catLabel(k);
            const en = CATS[k].label.toLowerCase();
            if (!col) return { label: cat, en };
            return { label: this.tf('color_item', { color: this.colorLabel(col), item: cat }), en: col + ' ' + en };
          };
          const out = [];
          const freshName = freshDes[0] || des[0];
          if (freshName) out.push(this.sq('idea_new_from', { name: freshName }, 'New from ' + freshName));
          const k0 = cats[0];
          if (k0) {
            const inCat = live.filter((it) => this.catKeyOf(it) === k0);
            const col = by(inCat, (it) => this.colorOf(it)).find((c) => W_COLOR[c]);
            const prices = inCat.map((it) => it.p).sort((x, y) => x - y);
            const mid = prices[Math.floor(prices.length / 2)] || 0;
            const band = mid ? Math.ceil(mid / 100 / 250) * 250 : 0;
            const item = itemOf(col, k0);
            const price = band ? this.money(band * 100) : '';
            out.push(band ? this.sq('idea_under', { item: item.label, price }, item.en + ' under ' + price) : { label: item.label, query: this.cjk() ? item.en : item.label });
          }
          const d2 = des.find((d) => d !== freshName);
          const k1 = d2 && by(live.filter((it) => it.v === d2), (it) => this.catKeyOf(it)).find((k) => CATS[k]);
          if (d2) {
            const item = k1 ? d2 + ' ' + this.catLabel(k1) : d2;
            const en = d2 + (k1 ? ' ' + CATS[k1].label.toLowerCase() : '');
            if (k1 && (this.S.profile.shoe || this.S.profile.size)) out.push(this.sq('idea_in_size', { item }, en + ' in my size'));
            else out.push({ label: item, query: this.cjk() ? en : item });
          }
          const saleCat = by(live.filter((it) => it.sale), (it) => this.catKeyOf(it)).find((k) => CATS[k]);
          if (saleCat) out.push(this.sq('idea_on_sale', { item: this.catLabel(saleCat) }, CATS[saleCat].label + ' on sale'));
          const k2 = cats.find((k) => k !== k0 && k !== saleCat);
          if (k2) out.push(des[2] ? this.sq('idea_by', { item: this.catLabel(k2), name: des[2] }, CATS[k2].label + ' by ' + des[2]) : { label: this.catLabel(k2), query: this.cjk() ? CATS[k2].label : this.catLabel(k2) });
          return out;
        })();
        return (this._trends = {
          dept, at: N, ideas,
          designers: boost(D, N.d.n).slice(0, 7).map((x) => x[0]),
          cats: boost(K, N.k.n).slice(0, 3).map((x) => x[0]),
          picks: (() => {
            const ranked = pool.map((it, i) => [it, 1 / (1 + i / 15) + this.affScore(it) * 2]).sort((x, y) => y[1] - x[1]).map((x) => x[0]);
            const out = [], per = {};
            ranked.forEach((it) => { if (out.length < 4 && (per[it.v] || 0) < 1) { out.push(it); per[it.v] = 1; } });
            ranked.forEach((it) => { if (out.length < 4 && !out.includes(it)) out.push(it); });
            return out;
          })()
        });
      }).catch(() => { this._trendsNull = true; return null; });
    }

    prompts() {
      const N = this.norm(), out = [], pr = this.S.profile;
      // Live suggestions from best sellers and new arrivals; the lines in the theme editor are only a last resort.
      const T = this._trends && this._trends.dept === pr.dept ? this._trends : null;
      const manual = String(this.cfg.prompts || '').split('\n').map((x) => x.trim()).filter(Boolean)
        .filter((x) => this.lookReady({}) || !/(look|outfit|style me|for a |voor een |habille|vestimi|visteme)/i.test(x))
        .map((x) => ({ label: x, query: x }));
      const fallback = T && T.ideas && T.ideas.length ? T.ideas : (T || this._trendsNull ? manual : []);
      const asPhrase = (x) => (x && typeof x === 'object' ? x : { label: x, query: x });
      if (N.signal) {
        const ds = this.top('d', 2, 1), ks = this.top('k', 2, 1), col = this.top('col', 1, 1.5)[0];
        const band = N.price ? Math.ceil((N.price * 1.25) / 100 / 250) * 250 : 0;
        if (ds[0]) out.push(this.sq('idea_new_from', { name: ds[0] }, 'New from ' + ds[0]));
        if (ks[0]) {
          const item = col ? this.tf('color_item', { color: this.colorLabel(col), item: this.catLabel(ks[0]) }) : this.catLabel(ks[0]);
          const enItem = (col ? col + ' ' : '') + CATS[ks[0]].label.toLowerCase();
          const price = band ? this.money(band * 100) : '';
          out.push(band ? this.sq('idea_under', { item, price }, enItem + ' under ' + price) : { label: item, query: this.cjk() ? enItem : item });
        }
        if (ds[0] && ks[1] && (pr.shoe || pr.size)) out.push(this.sq('idea_in_size', { item: ds[0] + ' ' + this.catLabel(ks[1]) }, ds[0] + ' ' + CATS[ks[1]].label.toLowerCase() + ' in my size'));
        else if (ds[1]) {
          const label = ds[1] + (ks[0] ? ' ' + this.catLabel(ks[0]) : '');
          const en = ds[1] + (ks[0] ? ' ' + CATS[ks[0]].label.toLowerCase() : '');
          out.push({ label, query: this.cjk() ? en : label });
        }
        if (ks[0]) out.push(this.sq('idea_on_sale', { item: this.catLabel(ks[0]) }, CATS[ks[0]].label + ' on sale'));
      }
      fallback.forEach((x) => { const p = asPhrase(x); if (out.length < 5 && !out.some((o) => o.query.toLowerCase() === p.query.toLowerCase())) out.push(p); });
      return out.slice(0, 5);
    }

    /* ---------- Events ---------- */
    bind() {
      const { q } = this.el;
      document.addEventListener('click', (e) => {
        const t = e.target.closest('[data-ls-open]');
        if (!t || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        e.stopPropagation();
        this.open(t.dataset.lsQuery || '', t.dataset.lsQuery ? 'link' : 'icon');
      }, true);
      document.addEventListener('keydown', (e) => this.onKey(e));
      q.addEventListener('input', () => {
        this._src = 'typed';
        this.S.removed.clear(); this.S.noFuzzy = false; this.S.noLook = false; this.S.lookIdx = {};
        this.el.clear.hidden = !q.value;
        clearTimeout(this.tInput);
        this.renderGhostOnly();
        this.tInput = setTimeout(() => this.render(), q.value.trim().length < 2 ? 0 : 150);
      });
      this.el.form.addEventListener('submit', (e) => {
        e.preventDefault();
        const el = this.navItems()[this.S.active];
        if (el) return this.activate(el);
        this.remember();
        if (!q.value.trim()) return;
        const url = this.enterUrl();
        // No collection or designer page to land on: the results are already live in the sheet, so stay here
        // (just drop the keyboard) instead of falling back to the stock Shopify search page.
        if (!url) { try { q.blur(); } catch (_) {} return; }
        this.trackViewAll();
        window.location.href = url;
      });
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('change', (e) => {
        const k = e.target.dataset.pf;
        if (!k) return;
        this.S.profile[k] = e.target.value; store.set('profile', this.S.profile); this.render();
      });
      this.el.mail.addEventListener('submit', (e) => { e.preventDefault(); this.mailSubmit(); });
      this.el.sheet.addEventListener('mouseover', (e) => {
        const card = e.target.closest('[data-nav]');
        if (card && this.S.active >= 0) { const items = this.navItems(); const i = items.indexOf(card); if (i >= 0) this.setActive(i, false); }
      });
      ['cart:update', 'cart:updated', 'cart:refresh'].forEach((ev) => document.addEventListener(ev, (e) => {
        if (e.detail && e.detail.data && e.detail.data.source === 'labels-search') return;
        const n = e?.detail?.resource?.item_count ?? e?.detail?.data?.itemCount ?? e?.detail?.cart?.item_count;
        if (typeof n === 'number') this.setCount(n, false);
      }));
      window.LabelsSearch = { open: (query) => this.open(query || '', 'api'), close: () => this.close() };
    }

    bindEditor() {
      document.addEventListener('shopify:block:select', (e) => { if (e.target === this) this.open('', 'editor'); });
      document.addEventListener('shopify:block:deselect', (e) => { if (e.target === this) this.close(); });
    }

    onKey(e) {
      const tag = (document.activeElement && document.activeElement.tagName) || '';
      const typing = /^(INPUT|TEXTAREA|SELECT)$/.test(tag) || (document.activeElement && document.activeElement.isContentEditable);
      if (this.hidden) {
        if ((e.key === '/' && !typing) || ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k')) { e.preventDefault(); this.open('', 'keyboard'); }
        return;
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        if (!this.el.mail.hidden) return this.mailClose();
        if (this.querySelector('.ls-sizes:not([hidden])')) return this.closeSizes();
        if (this.el.q.value) { this.setQuery(''); return; }
        return this.close();
      }
      if (e.key === 'Tab' && !e.shiftKey && document.activeElement === this.el.q && this.P && this.P.complete) {
        e.preventDefault(); this.complete(); return;
      }
      if (e.key === 'Tab') return this.trapFocus(e);
      if (document.activeElement !== this.el.q) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); this.setActive(this.S.active + 1, true); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); this.setActive(this.S.active - 1, true); }
    }

    trapFocus(e) {
      const f = [...this.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select')].filter((el) => el.offsetParent !== null && !el.closest('[hidden]'));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ---------- Open / close ---------- */
    open(query, trigger) {
      this.buildNav();
      this._norm = null;
      this.inferDept();
      // Fold away the mega menu (desktop panel or mobile sheet) before the search takes over.
      const mm = document.getElementById('labels-mm');
      if (mm) {
        if (typeof mm.close === 'function') mm.close();
        const shut = mm.querySelector('[data-mm-sheet]:not([hidden]) [data-mm-mclose]');
        if (shut) shut.click();
      }
      this.lastFocus = document.activeElement;
      if (this.hidden) {
        this.hidden = false;
        this.classList.remove('is-closing');
        document.documentElement.classList.add('ls-locked');
        this.dispatchEvent(new CustomEvent('labels-search:open', { bubbles: true }));
        const A = this.ana();
        if (A) A.newSearch();
        this._sentQ = new Set();
        this._pendingQ = null;
        this._lastTerm = '';
        this._sess = { t0: Date.now(), select: false, add: false };
        this.track('labels_search_open', { trigger: trigger || 'api' });
      }
      this._src = query ? 'prefill' : 'typed';
      this.el.q.value = query || '';
      this.el.clear.hidden = !this.el.q.value;
      // Focus straight away (inside the tap) so phones raise the keyboard.
      try { this.el.q.focus({ preventScroll: true }); } catch (_) { this.el.q.focus(); }
      this.S.removed.clear(); this.S.noFuzzy = false; this.S.noLook = false; this.S.lookIdx = {};
      this.refreshViewed();
      this.render();
    }

    close() {
      if (this.hidden) return;
      this.flushQuery();
      const sess = this._sess || {};
      this.track('labels_search_close', {
        duration_ms: sess.t0 ? Date.now() - sess.t0 : 0,
        had_select: !!sess.select,
        had_add: !!sess.add,
        last_term: this.el.q.value.trim() || this._lastTerm || ''
      });
      this._sess = null;
      clearTimeout(this.tRemember);
      this._lensImg = null;
      if (this.el.q.value.trim().length >= 2) this.remember();
      this.mailClose();
      const done = () => {
        this.hidden = true;
        this.classList.remove('is-closing');
        document.documentElement.classList.remove('ls-locked');
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
      else { this.classList.add('is-closing'); setTimeout(done, 260); }
      if (this.lastFocus && this.lastFocus.focus) { try { this.lastFocus.focus({ preventScroll: true }); } catch (_) {} }
    }

    setQuery(v) {
      this.el.q.value = v;
      this.el.clear.hidden = !v;
      this.S.removed.clear(); this.S.noFuzzy = false; this.S.noLook = false; this.S.tone = null; this.S.lookIdx = {};
      this.render();
      try { this.el.q.focus({ preventScroll: true }); } catch (_) {}
      this.el.sheet.scrollTop = 0;
    }

    // Where Enter goes: a designer, category, sale or filtered collection page. Never the stock /search page.
    enterUrl() {
      const url = this.seeAllUrl;
      if (!url) return null;
      const path = (u) => String(u).split(/[?#]/)[0].replace(/\/+$/, '');
      return path(url) === path(this.cfg.searchUrl) ? null : url;
    }

    remember() {
      const v = this.el.q.value.trim();
      if (!v) return;
      const lv = v.toLowerCase();
      // Keep the last 10 searches; drop half-typed versions of this one ("gre", "grey" when "grey pants" is saved)
      this.S.recent = [v, ...this.S.recent.filter((r) => { const lr = r.toLowerCase(); return lr !== lv && !lv.startsWith(lr); })].slice(0, 10);
      store.set('recent', this.S.recent);
      if (this.P && this._learnedQ !== v.toLowerCase()) { this._learnedQ = v.toLowerCase(); this.learnIntent(this.P, 1.5); }
    }

    complete() {
      if (!this.P || !this.P.complete) return;
      this._src = 'complete';
      this.el.q.value = this.P.complete + ' ';
      this.S.removed.clear();
      this.render();
      this.el.q.focus();
    }

    /* ============================================================
       Intent parser
       ============================================================ */
    parse(raw) {
      const S = this.S;
      // A SKU (158542, 158542-M) is a direct lookup: no size, price or department reading.
      const sku = SKU_RE.exec(raw);
      if (sku) return { raw, cats: null, catKey: null, free: [sku[1]], ignored: [], sku: true };
      const p = { raw, cats: null, catKey: null, free: [], ignored: [] };
      let s = ' ' + norm(raw).replace(/[^a-z0-9€<>.,\- ]/g, ' ') + ' ';
      const setPrice = (k) => (m, n) => { const v = num(n); if (v > 0) p[k] = v; return ' '; };
      s = s.replace(/(?:under|onder|unter|below|beneath|maximum|max|less than|tot|bis|up to|sous|sotto|bajo|<)\s*(?:€|eur|euro)?\s*(\d[\d.,]*)\s*(?:€|eur|euro|euros)?/g, setPrice('priceMax'));
      s = s.replace(/(?:over|boven|uber|above|vanaf|ab|more than|>)\s*(?:€|eur|euro)?\s*(\d[\d.,]*)\s*(?:€|eur|euro|euros)?/g, setPrice('priceMin'));
      s = s.replace(/€\s*(\d[\d.,]*)/g, setPrice('priceMax'));
      s = s.replace(/(?:^| )(?:in |a |en |nella )?(?:my|mijn|meine|meiner|ma|mia|mi) (?:size|sizes|maat|maten|grosse|groesse|taille|taglia|talla)(?= )/g, () => { p.mySize = true; return ' '; });
      s = s.replace(/(?:^| )(?:size|maat|grosse|groesse|gr|eu|taille|taglia|talla|pointure)\s*(xxs|xs|s|m|l|xl|xxl|\d{2}(?:[.,]5)?)(?= )/g, (m, v) => { if (/\d/.test(v)) p.shoe = v.replace(',', '.'); else p.size = v.toUpperCase(); return ' '; });
      s = s.replace(/(?:^| )(3[4-9]|4[0-8])(?= )/g, (m, v) => { p.shoe = v; return ' '; });
      s = s.replace(/(?:^| )(xxs|xs|xl|xxl)(?= )/g, (m, v) => { p.size = v.toUpperCase(); return ' '; });
      s = s.replace(/(?:^| )(?:all|total|head to toe|helemaal|ganz|full|tout|tutto|todo) (?:black|zwart|schwarz|noir|nero|negro)(?= )/g, () => { p.color = 'black'; p.look = true; return ' '; });
      s = s.replace(/(?:^| )(?:just in|new in|this week|deze week|new arrivals)(?= )/g, () => { p.newOnly = true; return ' '; });
      s = s.replace(/(?:^| )style me(?= )/g, () => { p.look = true; return ' '; });
      s = s.replace(/[.,]/g, ' ');
      s = ' ' + clean(s) + ' ';
      for (const [alias, name] of this.fullAliases) {
        const re = new RegExp('(^| )' + escRe(alias) + '(?= |$)');
        if (re.test(s)) { p.designer = name; p._dwords = alias.split(' '); s = s.replace(re, ' '); break; }
      }
      const rest = [];
      s.split(/\s+/).filter(Boolean).forEach((w) => {
        if (W_CAT[w] && !p.catKey) { p.catKey = W_CAT[w]; p.cats = CATS[p.catKey]; }
        else if (W_COLOR[w]) p.color = W_COLOR[w];
        else if (W_DEPT[w]) p.dept = W_DEPT[w];
        else if (W_FLAG[w]) p[W_FLAG[w]] = true;
        else if (W_OCC[w]) { p.occasion = W_OCC[w]; p.look = true; }
        else if (W_LOOK.has(w)) p.look = true;
        else rest.push(w);
      });
      // Typos in whole names first ("rik owens"), then short names ("owens", "margiela"), then single-word typos ("balenciega")
      const fuzzy = (minN, maxN, list) => {
        for (let n = Math.min(maxN, rest.length); n >= minN; n--) {
          for (let i = 0; i + n <= rest.length; i++) {
            const phrase = rest.slice(i, i + n).join(' ');
            if (phrase.length < 4) continue;
            let best = null, bd = 9;
            for (const [alias, name] of list) {
              if (Math.abs(alias.length - phrase.length) > 2) continue;
              const d = lev(phrase, alias);
              if (d <= (alias.length >= 9 ? 2 : 1) && d < bd) { bd = d; best = name; }
            }
            if (best) { p.designer = best; p.corrected = bd > 0 ? phrase : ''; p._dwords = rest.slice(i, i + n); rest.splice(i, n); return true; }
          }
        }
        return false;
      };
      if (!p.designer && rest.length && !S.noFuzzy) fuzzy(2, 3, this.fullAliases.filter(([a]) => a.includes(' ')));
      if (!p.designer && rest.length) {
        const i = rest.findIndex((w) => this.partAliases.some(([a]) => a === w));
        if (i >= 0) { p.designer = this.partAliases.find(([a]) => a === rest[i])[1]; p._dwords = [rest[i]]; rest.splice(i, 1); }
      }
      if (!p.designer && rest.length && !S.noFuzzy) fuzzy(1, 1, this.fuzzyAliases);
      // Autocomplete for the words still being typed: "rick ow", "rik ow"
      const typed = clean(raw);
      if (!p.designer && rest.length && !S.noFuzzy) {
        for (let n = Math.min(3, rest.length); n >= 1; n--) {
          const tail = rest.slice(-n).join(' ');
          if (tail.length < 3 || !typed.endsWith(tail)) continue;
          let hit = this.prefixAliases.find(([a]) => a.startsWith(tail) && a.length > tail.length);
          const exact = !!hit;
          if (!hit && tail.length >= 4) hit = this.prefixAliases.find(([a]) => a.length > tail.length && Math.min(lev(tail, a.slice(0, tail.length)), lev(tail, a.slice(0, tail.length + 1))) <= 1);
          if (hit) {
            p.designer = hit[1];
            p.corrected = exact ? '' : tail;
            const nameLc = clean(hit[1]);
            const rawLc = raw.replace(/\s+$/, '');
            const cut = rawLc.length - (exact ? tail.length : rawLc.split(' ').slice(-n).join(' ').length);
            p.complete = rawLc.slice(0, cut) + nameLc;
            p.ghost = exact && nameLc.startsWith(tail) && p.complete.toLowerCase().startsWith(rawLc.toLowerCase()) ? p.complete.slice(rawLc.length) : '';
            p._dwords = rest.slice(-n);
            rest.splice(rest.length - n, n);
            break;
          }
        }
      }
      p.free = rest.filter((w) => w.length > 1 && !STOP.has(w));
      if (p.look) p.free = [];
      if (S.noLook) p.look = false;
      if (p.look && !this.lookReady(p)) p.look = false;
      S.removed.forEach((k) => {
        if (k.startsWith('free:')) p.free = p.free.filter((w) => w !== k.slice(5));
        else if (k === 'cats') { p.cats = null; p.catKey = null; }
        else if (k === 'look') p.look = false;
        else if (k === 'designer') {
          // Dismissing the designer reading hands its words back to the text search, otherwise nothing filters
          // and the sheet shows the whole catalogue.
          const back = (p._dwords || []).filter((w) => w.length > 1 && !STOP.has(w) && !p.free.includes(w));
          if (!p.look) p.free = p.free.concat(back);
          p.designer = undefined; p.corrected = ''; p.complete = ''; p.ghost = ''; p._dwords = undefined;
        } else p[k] = undefined;
      });
      // A department the shopper chose in their profile filters every search (unisex stays in);
      // words in the query win, and the chip can be removed for this search.
      if (!p.dept && S.profile.deptSet && S.profile.dept && !S.removed.has('dept')) { p.dept = S.profile.dept; p._deptProfile = true; }
      return p;
    }

    lookReady(p) {
      const urls = (this.cfg.look || {})[p.dept || this.S.profile.dept] || [];
      return this.cfg.lookOn && urls.filter(Boolean).length >= 2;
    }

    /* ============================================================
       Product logic
       ============================================================ */
    prep(o) {
      if (o._p) return o;
      o._p = true;
      if (o.si == null) o.si = -1;
      if (!o.vs) o.vs = [];
      o.hay = clean([o.t, o.v, o.pt, (o.tg || []).join(' ')].join(' '));
      const col = Array.isArray(o.col) ? o.col.join(' ') : (o.col || '');
      o.colorHay = clean([o.t, col, String(o.h || '').replace(/-/g, ' '), (o.tg || []).join(' '), o.ci >= 0 ? (o.vs || []).map((v) => v[2][o.ci]).join(' ') : ''].join(' '));
      o.sale = o.c > o.p;
      o.isNew = o.n && Date.now() / 1000 - o.n < (this.cfg.newDays || 45) * 86400;
      const words = (list) => new Set(list.flatMap((x) => clean(String(x).replace(/[-_]/g, ' ')).split(' ')));
      const side = (set) => {
        const w = this.womenTags.some((t) => set.has(t)), m = this.menTags.some((t) => set.has(t));
        return w && !m ? 'w' : m && !w ? 'm' : w && m ? 'u' : null;
      };
      const cl = (o.cl || []).map(String);
      const dh = this.cfg.deptHandle || {};
      const byTag = side(words([...(o.tg || []), o.pt || '']));
      const byCol = (dh.w && cl.includes(dh.w)) && !(dh.m && cl.includes(dh.m)) ? 'w' : (dh.m && cl.includes(dh.m)) && !(dh.w && cl.includes(dh.w)) ? 'm' : side(words(cl));
      const dd = byTag && byTag !== 'u' ? byTag : byTag === 'u' ? null : byCol === 'u' ? null : byCol;
      o.dept = dd || o._dept || null;
      if (o.si >= 0) {
        const vals = uniq((o.vs || []).map((v) => v[2][o.si]));
        o.sizes = vals;
        o.oneSize = vals.length > 0 && vals.every((x) => ONE_SIZE.test(clean(x)));
        o.sys = this.sizeSystem(o.pt, vals);
        o.ukUs = o.sys === 'shoe' && vals.some((x) => /^\s*(uk|us)\b/i.test(String(x)));
      }
      const key = String(o.id);
      if (!(o.lite && this.items.has(key) && !this.items.get(key).lite)) this.items.set(key, o);
      return o;
    }

    // Italian clothing sizes (44–56) overlap EU shoe sizes, so the product type decides; the size
    // values only decide when there is no usable type, and then only with an odd or half size.
    sizeSystem(type, vals) {
      const pt = clean(type || '');
      if (/[a-z]/.test(pt)) return pt.split(' ').some((w) => !w.startsWith('bootcut') && FOOTWEAR_STEMS.some((s) => w.startsWith(s))) ? 'shoe' : 'cloth';
      const nums = vals.map((x) => parseFloat(String(x).replace(/[^\d.,]/g, '').replace(',', '.'))).filter((n) => n >= 34 && n <= 48);
      return nums.length >= vals.length / 2 && nums.some((n) => n % 2 !== 0) ? 'shoe' : 'cloth';
    }

    nsz(x) { return clean(x).toUpperCase().replace(/\b(EU|IT|FR|UK|US|SIZE|MAAT|GR)\b/g, '').replace(/\s+/g, '').replace(',', '.'); }

    // Size facts for one product: which size counts for this shopper and is it in stock?
    sizeInfo(it, p) {
      const vs = it.vs || [];
      const colorOk = (v) => !(p && p.color) || it.ci < 0 || COLORS[p.color].split(' ').some((w) => clean(v[2][it.ci]).includes(w));
      if (it.si < 0 || it.oneSize) {
        const v = vs.find((x) => x[1] && colorOk(x)) || vs.find((x) => x[1]);
        return { need: false, v, n: v ? (v[3] == null ? 99 : v[3]) : 0 };
      }
      const want = it.sys === 'shoe' ? ((p && p.shoe) || this.S.profile.shoe) : ((p && p.size) || this.S.profile.size);
      const label = (x) => (it.sys === 'shoe' ? this.tf('eu_size', { size: x }) : x);
      // EU shoe sizes cannot be compared with UK/US sizing (conversion differs per brand).
      if (!want || it.ukUs) return { need: true, want: null };
      const key = this.nsz(want);
      const cand = vs.filter((v) => this.nsz(v[2][it.si]) === key);
      const v = cand.find((x) => x[1] && colorOk(x)) || cand.find((x) => x[1]) || cand[0];
      const n = !v ? -1 : !v[1] ? 0 : v[3] == null ? 99 : Math.max(v[3], 1);
      return { need: true, want, label: label(want), v, n };
    }

    wantsSize(p) { return !!(p.shoe || p.size || p.mySize); }

    catOk(it, cat) { return cat.stems.some((st) => it.hay.includes(st)); }
    colorOk(it, c) { return COLORS[c].split(' ').some((w) => (' ' + it.colorHay + ' ').includes(' ' + w)); }

    matches(it, p, skip) {
      const sk = skip || '';
      if (p.designer && sk !== 'designer') {
        const v = clean(it.v), d = clean(p.designer);
        if (!(v === d || v.startsWith(d + ' '))) return false;
      }
      if (p.cats && sk !== 'cats' && !this.catOk(it, p.cats)) return false;
      if (p.color && sk !== 'color' && !p._serverColor && !this.colorOk(it, p.color)) return false;
      if (p.dept && sk !== 'dept' && it.dept && it.dept !== p.dept) return false;
      if (p.priceMax && sk !== 'priceMax' && it.p > p.priceMax * 100) return false;
      if (p.priceMin && sk !== 'priceMin' && it.p < p.priceMin * 100) return false;
      if (p.sale && sk !== 'sale' && !it.sale) return false;
      if (p.newOnly && sk !== 'newOnly' && !it.isNew) return false;
      if (this.wantsSize(p) && sk !== 'size') { const si = this.sizeInfo(it, p); if (si.need && si.want && !(si.n > 0)) return false; }
      if (p._filterFree && sk !== 'free' && p.free.some((w) => !it.hay.includes(w))) return false;
      return true;
    }

    rank(list, p) {
      const score = (it) => { const si = this.sizeInfo(it, p); return (it.a ? 8 : 0) + (si.need && si.n > 0 ? 4 : 0) + (it.dept === this.S.profile.dept ? 2 : 0) + (it.isNew ? 1 : 0) + this.affScore(it) * 4; };
      const sort = p.cheap ? 'price' : this.S.sort;
      const withIdx = list.map((it, i) => [it, i, score(it)]);
      withIdx.sort((a, b) =>
        sort === 'price' ? (b[0].a - a[0].a) || a[0].p - b[0].p :
        sort === 'new' ? (b[0].a - a[0].a) || (b[0].n - a[0].n) :
        (b[2] - a[2]) || (a[1] - b[1]));
      return withIdx.map((x) => x[0]);
    }

    /* ============================================================
       Fetching
       ============================================================ */
    // Search results never show sold-out pieces: Shopify drops them server-side (smaller payload,
    // and the 48/100 result slots are filled with pieces that can be bought).
    view(url, extra, name) {
      if (!url) return null;
      const n = name || 'labels-search';
      const all = url + (extra || '');
      const avail = n !== 'labels-search' || /[?&](filter\.v\.availability|options%5Bunavailable_products%5D)=/.test(all) ? ''
        : /\/search(\?|$)/.test(url) ? '&options%5Bunavailable_products%5D=hide' : '&filter.v.availability=1';
      return url + (url.includes('?') ? '&' : '?') + 'view=' + n + (extra || '') + avail;
    }

    get(url) {
      if (!url) return Promise.resolve(null);
      if (this.cache.has(url)) return this.cache.get(url);
      const pr = fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then((r) => (r.ok ? r.text() : null))
        .then((t) => {
          if (!t) return null;
          const j = JSON.parse(t.trim());
          const lite = url.includes('view=labels-trend');
          if (url.includes('view=labels-search') && j.items) j.items = j.items.filter((o) => o.a);
          (j.items || []).forEach((o) => { if (lite) o.lite = true; this.prep(o); });
          return j;
        })
        .catch(() => null);
      this.cache.set(url, pr);
      pr.then((j) => { if (!j) this.cache.delete(url); });
      return pr;
    }

    // Views return one page (collections 100, search 48). Filters applied in the browser (sale, new, size)
    // need the whole list, otherwise "men jackets on sale" misses sale pieces past page one.
    async getPages(url, max = 5) {
      const per = /\/search\?/.test(url) ? 48 : 100;
      const first = await this.get(url);
      if (!first || !first.items || !(first.count > per)) return first;
      const pages = Math.min(max, Math.ceil(first.count / per));
      const rest = await Promise.all(Array.from({ length: pages - 1 }, (_, i) => this.get(url + '&page=' + (i + 2))));
      return Object.assign({}, first, { items: first.items.concat(...rest.map((r) => (r && r.items) || [])) });
    }

    searchUrl(q) { return this.view(this.cfg.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'); }

    async brand(vendor) {
      const key = 'brand:' + vendor;
      if (this.cache.has(key)) return this.cache.get(key);
      const pr = (async () => {
        // Available pieces only (Shopify's own availability filter), so counts never include sold-out items.
        const withAvail = async (res, base) => {
          if (!res) return res;
          const av = await this.get(this.view(base, '&filter.v.availability=1'));
          return Object.assign({}, res, { availItems: av ? av.items || [] : null, availCount: av ? av.count : null });
        };
        // The vendor collection is the source of truth for items and counts: a /collections/<designer>
        // handle can be a redirect or a curated subset (e.g. /collections/rick-owens → kids-rick-owens).
        // That collection is only used for its description and image.
        const ownUrl = this.cfg.collectionsUrl + '/' + handleize(vendor);
        const vcUrl = this.cfg.collectionsUrl + '/vendors?q=' + encodeURIComponent(vendor);
        const [own, vc] = await Promise.all([this.get(this.view(ownUrl)), this.get(this.view(vcUrl))]);
        if (vc && (vc.items || []).length) {
          const res = Object.assign({}, vc, { url: vcUrl });
          if (own) { res.desc = res.desc || own.desc; res.img = res.img || own.img; }
          return withAvail(res, vcUrl);
        }
        const mine = own && (own.items || []).filter((it) => clean(it.v) === clean(vendor) || clean(it.v).startsWith(clean(vendor) + ' '));
        if (own && mine.length && mine.length >= own.items.length * 0.6) return withAvail(Object.assign({ brand: true }, own), ownUrl);
        return own || { items: [], count: 0 };
      })();
      this.cache.set(key, pr);
      return pr;
    }

    navFor(p) {
      if (!p.cats || !this.nav) return [];
      const depts = p.dept ? [p.dept] : [this.S.profile.dept, this.S.profile.dept === 'm' ? 'w' : 'm'];
      const hits = this.nav.filter((n) => p.cats.stems.some((st) => n.n.includes(st)) && n.url.includes('/collections/') && !/^(all|alle)\b/.test(n.n));
      const typed = clean(p.raw).split(' ').filter((w) => w.length > 2 && W_CAT[w]).map((w) => w.replace(/(en|s)$/, ''));
      const said = (n) => (typed.some((w) => n.n.includes(w)) ? 0 : 1);
      hits.sort((a, b) => said(a) - said(b) || (depts.indexOf(a.dk) + 1 || 9) - (depts.indexOf(b.dk) + 1 || 9));
      return hits;
    }

    // The store's own colour facet values (e.g. "Pink & Purple"), loaded once from /collections/all?view=labels-colors.
    facets() {
      if (!this._facetP) {
        this._facetP = fetch(this.cfg.collectionsUrl + '/all?view=labels-colors', { credentials: 'same-origin' })
          .then((r) => (r.ok ? r.text() : null)).then((t) => (t ? JSON.parse(t.trim()) : null)).catch(() => null)
          .then((j) => {
            // Shopify returns filter values HTML-escaped ("Pink &amp; Purple"); decode before using them in URLs.
            const dec = (v) => String(v).replace(/&amp;/g, '&').replace(/&#39;|&#039;/g, "'").replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
            this._facet = j && j.values ? j.values.map(dec) : [];
            return this._facet;
          });
      }
      return this._facetP;
    }
    colorValue(c) {
      if (!c) return '';
      const vals = this._facet || [];
      const alias = { silver: ['metallic'], gold: ['metallic'], beige: ['beige', 'nude'], purple: ['purple'], orange: ['orange'] };
      const want = alias[c] || [c];
      const parts = (v) => norm(v).split(/\s*(?:&|,|\/|\band\b|\+)\s*/).map((x) => x.trim());
      for (const w of want) {
        const hit = vals.find((v) => parts(v).includes(w)) || vals.find((v) => norm(v).includes(w));
        if (hit) return hit;
      }
      return c[0].toUpperCase() + c.slice(1);
    }
    filterQS(p) {
      let q = '';
      if (p.color && this.cfg.colorParam) q += '&' + encodeURIComponent(this.cfg.colorParam) + '=' + encodeURIComponent(this.colorValue(p.color));
      if (p.priceMax) q += '&filter.v.price.lte=' + p.priceMax;
      if (p.priceMin) q += '&filter.v.price.gte=' + p.priceMin;
      return q;
    }
    // The shopper's own words minus prices and sizes: "grey pants under 500" -> "grey pants"
    plainWords(p) {
      let t = ' ' + norm(p.raw).replace(/[^a-z0-9€ ]/g, ' ') + ' ';
      t = t.replace(/(under|onder|unter|below|max|tot|bis|over|boven|above|vanaf|ab|sous|sotto|bajo)\s*€?\s*\d[\d.,]*/g, ' ')
           .replace(/€\s*\d[\d.,]*/g, ' ')
           .replace(/(size|maat|grosse|groesse|gr|eu|taille|taglia|talla|pointure)\s*(xxs|xs|s|m|l|xl|xxl|\d{2})\b/g, ' ')
           .replace(/\b(3[4-9]|4[0-8])\b/g, ' ');
      const EN = { boots: 'boots', sneakers: 'sneakers', shoes: 'shoes', loafers: 'loafers', sandals: 'sandals', coat: 'coat', jacket: 'jacket', outerwear: 'jacket',
        knit: 'sweater', tops: 'top', trousers: 'pants', shorts: 'shorts', skirt: 'skirt', dress: 'dress', bags: 'bag', accessories: 'accessories' };
      const english = new Set('boot boots sneaker sneakers trainers runner runners shoe shoes loafer loafers sandal sandals coat coats jacket jackets blazer sweater sweaters jumper hoodie hoodies cardigan knit knitwear t-shirt tshirt tee tees shirt shirts top tops polo trousers pants jeans denim cargo shorts skirt skirts dress dresses bag bags clutch tote backpack belt wallet scarf hat cap'.split(' '));
      return t.split(/\s+/).filter((w) => w && !STOP.has(w) && !W_COLOR[w] && !W_DEPT[w])
        .map((w) => (W_CAT[w] && !english.has(w) ? EN[W_CAT[w]] || w : w)).join(' ');
    }

    async gather(p) {
      if (p.color) await this.facets();
      // Where to look, from most to least precise.
      if (p.designer) {
        const b = await this.brand(p.designer);
        p._filterFree = true;
        return { items: (b.items || []).slice(), brand: b };
      }
      const urls = [];
      const navHits = this.navFor(p);
      const needDept = p.dept ? navHits.filter((n) => n.dk === p.dept) : navHits;
      if (p.cats && !p.free.length && needDept.length) {
        const list = uniq(needDept.map((n) => n.url)).slice(0, p.dept ? 2 : 3);
        const f = this.filterQS(p);
        const deep = p.sale || p.newOnly || p.cheap || this.wantsSize(p);
        const fetchAll = (u) => (deep ? this.getPages(u) : this.get(u));
        if (f) {
          // Let Shopify filter the whole collection (colour metafield, price), not just the first 100 pieces.
          const fr = await Promise.all(list.map((u) => fetchAll(this.view(u, f))));
          const fitems = [], fseen = new Set();
          fr.forEach((r) => (r && r.items || []).forEach((it) => { if (!fseen.has(it.id)) { fseen.add(it.id); fitems.push(it); } }));
          if (fitems.length) { p._filterFree = true; p._serverColor = !!p.color; return { items: fitems, navHits }; }
        }
        if (deep) {
          const dr = await Promise.all(list.map((u) => this.getPages(this.view(u))));
          if (dr.every((r) => r === null)) throw new Error('offline');
          const ditems = [], dseen = new Set();
          dr.forEach((r) => (r && r.items || []).forEach((it) => { if (!dseen.has(it.id)) { dseen.add(it.id); ditems.push(it); } }));
          p._filterFree = true;
          return { items: ditems, navHits };
        }
        list.forEach((u) => urls.push(this.view(u)));
        p._filterFree = true;
      } else if (p.cats || p.free.length || p.color) {
        const terms = p.free.join(' ');
        const stems = p.cats ? p.cats.stems.slice(0, 3) : [''];
        stems.forEach((st) => { const qq = [st, terms].filter(Boolean).join(' ') || (p.color ? COLORS[p.color].split(' ')[0] : ''); if (qq) urls.push(this.searchUrl(qq)); });
      } else if (p.sale && this.cfg.sale) urls.push(this.view(this.cfg.sale));
      else if (p.newOnly && this.cfg.newIn) urls.push(this.view(this.cfg.newIn));
      else urls.push(this.view(this.cfg.collectionsUrl + '/all', p.newOnly ? '&sort_by=created-descending' : p.cheap ? '&sort_by=price-ascending' : ''));
      const deepAll = p.sale || p.newOnly || p.cheap || this.wantsSize(p);
      const res = await Promise.all(uniq(urls).map((u) => (deepAll && !u.includes('sort_by=') ? this.getPages(u, /\/search\?/.test(u) ? 3 : 5) : this.get(u))));
      if (res.every((r) => r === null)) throw new Error('offline');
      const seen = new Set(), items = [];
      res.forEach((r) => (r && r.items || []).forEach((it) => { if (!seen.has(it.id)) { seen.add(it.id); items.push(it); } }));
      return { items, navHits };
    }

    /* ============================================================
       Rendering
       ============================================================ */
    money(cents) {
      const fmt = this.cfg.moneyFormat || '€{{amount}}';
      const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      const map = { amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'], amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','], amount_with_apostrophe_separator: [2, "'", '.'], amount_with_period_and_space_separator: [2, ' ', '.'], amount_with_space_separator: [2, ' ', ','] };
      const [dec, th, ds] = map[m ? m[1] : 'amount'] || map.amount;
      const [i, f] = (cents / 100).toFixed(dec).split('.');
      let out = i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? ds + f : '');
      out = out.replace(new RegExp('\\' + ds + '00$'), '');
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '');
    }

    srcset(url) {
      if (!url) return '';
      if (!/width=\d+/.test(url)) return `src="${esc(url)}"`;
      return `src="${esc(url)}" srcset="${[320, 480, 640, 960].map((w) => esc(url.replace(/width=\d+/, 'width=' + w)) + ' ' + w + 'w').join(', ')}"`;
    }

    badge(it, p, si) {
      const hot = (t) => `<span class="ls-tag ls-tag--hot">${esc(t)}</span>`;
      if (!it.a) return `<span class="ls-tag">${esc(this.tf('sold_out'))}</span>`;
      if (si.need && si.want) {
        if (si.n === -1) return `<span class="ls-tag">${esc(this.tf('not_in', { size: si.label }))}</span>`;
        if (si.n === 0) return `<span class="ls-tag">${esc(this.tf('sold_out_in', { size: si.label }))}</span>`;
        if (si.n === 1) return hot(this.tf('last_one_in', { size: si.label }));
        if (si.n <= 3) return hot(this.tf('left_in', { count: si.n, size: si.label }));
      } else if (!si.need && si.n > 0 && si.n <= 2) return hot(si.n === 1 ? this.tf('last_one') : this.tf('two_left'));
      if (it.priceDrop) return hot(this.tf('price_dropped'));
      if (it.sale) return hot(this.tf('sale'));
      if (it.isNew) return `<span class="ls-tag">${esc(this.tf('new'))}</span>`;
      return '';
    }

    price(it) { return it.sale ? `<b>${this.money(it.p)}</b><s>${this.money(it.c)}</s>` : this.money(it.p); }

    tf(key, vars) {
      const bag = this.cfg.str || {};
      let s = bag[key];
      if (s == null) return '';
      s = String(s);
      if (vars) Object.keys(vars).forEach((k) => { s = s.split('__' + String(k).toUpperCase() + '__').join(vars[k] == null ? '' : String(vars[k])); });
      return s;
    }
    tn(base, n, vars) { return this.tf(base + (Number(n) === 1 ? '_one' : '_other'), Object.assign({ count: n }, vars || {})); }
    cjk() { return /^(ja|ko|zh)/i.test(this.cfg.locale || ''); }
    catLabel(key) { return this.tf('cat_' + key) || (CATS[key] && CATS[key].label) || ''; }
    colorLabel(key) { const t = this.tf('color_' + key); return t || (key ? key.charAt(0).toUpperCase() + key.slice(1) : ''); }
    sq(key, vars, enQuery) { const label = this.tf(key, vars); return { label, query: this.cjk() ? enQuery : label }; }
    seeAll(n, arrow) {
      if (n >= 100) return this.tf(arrow ? 'see_all_many_arrow' : 'see_all_many');
      return this.tf((Number(n) === 1 ? 'see_all_one' : 'see_all_other') + (arrow ? '_arrow' : ''), { count: n });
    }
    pieces(n) { return this.tf(Number(n) === 1 ? 'pieces_available_one' : 'pieces_available_other', { count: n >= 100 ? n + '+' : n }); }

    card(it, p, o) {
      o = o || {};
      if (it.lite) o = Object.assign({}, o, { noQa: true });
      const si = this.sizeInfo(it, p);
      let act = 'qa', label = this.tf('add_to_bag'), soft = false;
      if (!it.a) { act = this.cfg.klaviyo ? 'sizes' : ''; label = this.tf('notify_me'); soft = true; }
      else if (si.need && si.want && si.n > 0) label = this.tf('add_size', { size: si.label });
      else if (si.need) { act = 'sizes'; label = si.want ? this.tf('other_sizes') : this.tf('select_size'); soft = !!si.want; }
      const sz = p && p.sku ? '(min-width: 990px) 22vw, 100vw' : '(min-width: 990px) 22vw, 46vw';
      const img = it.img ? `<img ${this.srcset(it.img)} sizes="${sz}" alt="${esc(it.t)}" loading="lazy">${it.img2 ? `<img ${this.srcset(it.img2)} sizes="${sz}" alt="" loading="lazy">` : ''}` : '';
      return `<article class="ls-card" data-nav data-pid="${it.id}" style="--i:${o.i || 0}">
        <div class="ls-card__m">
          <a class="ls-card__img" href="${esc(it.u)}" tabindex="-1" aria-hidden="true" data-act="open">${img}</a>
          ${o.slot ? `<span class="ls-slot">${esc(o.slot)}</span>` : this.badge(it, p, si)}
          ${o.swap ? `<button class="ls-swap" type="button" data-act="swap" data-v="${esc(o.slotId || o.slot)}" aria-label="${esc(this.tf('swap', { slot: o.slot }))}">${ICON_SWAP}${esc(o.count)}</button>` : ''}
          ${act && !o.noQa ? `<button class="ls-qa${soft ? ' ls-qa--soft' : ''}" type="button" data-act="${act}" data-v="${it.id}" aria-label="${esc(label + ': ' + it.v + ' ' + it.t)}"><span>${esc(label)}</span>${ICON_BAG}</button>` : ''}
          <div class="ls-sizes" data-sizes hidden></div>
        </div>
        <a class="ls-card__txt" href="${esc(it.u)}" data-act="open">
          <span class="ls-card__v">${esc(it.v)}</span>
          <span class="ls-card__t">${esc(it.t)}</span>
          <span class="ls-card__p">${this.price(it)}</span>
          ${p && p.sku ? this.sizeRun(it) : ''}
        </a>
      </article>`;
    }

    // In-stock sizes as on the product card in collections: "M · L", "EU 45" written "EU45".
    sizeRun(it) {
      if (it.si < 0) return '';
      const sizes = uniq((it.vs || []).filter((v) => v[1]).map((v) => String(v[2][it.si]).trim().replace(/\b(EU|FR|UK|IT|US) /g, '$1')));
      if (!sizes.length) return '';
      return `<span class="ls-card__sizes"><span class="visually-hidden">${esc(sizes.join(', '))}</span><span aria-hidden="true">${sizes.map(esc).join('<i>·</i>')}</span></span>`;
    }

    skeleton(n) {
      return `<div class="ls-cards">${Array.from({ length: n }, () => '<div><div class="ls-skel"></div><div class="ls-skel-line"></div><div class="ls-skel-line" style="width:40%"></div></div>').join('')}</div>`;
    }

    chip(key, k, v, soft) {
      return `<button class="ls-chip${soft ? ' ls-chip--soft' : ''}" type="button" data-act="rm" data-v="${esc(key)}" aria-label="${esc(this.tf('remove', { label: k + ' ' + v }))}"><small>${esc(k)}</small>${esc(v)}<i aria-hidden="true">×</i></button>`;
    }

    sizeLabel(p) {
      if (p.shoe) return this.tf('eu_size', { size: p.shoe });
      if (p.size) return this.tf('size_word', { size: p.size });
      if (p.cats && ['boots', 'sneakers', 'shoes', 'loafers', 'sandals'].includes(p.catKey) && this.S.profile.shoe) return this.tf('eu_size', { size: this.S.profile.shoe });
      return this.tf('your_size');
    }

    renderChips(p, count, mode) {
      const c = [];
      if (p.designer) c.push(this.chip('designer', this.tf('chip_designer'), p.designer));
      if (p.cats) c.push(this.chip('cats', this.tf('chip_item'), this.catLabel(p.catKey)));
      if (p.color) c.push(this.chip('color', this.tf('chip_colour'), this.colorLabel(p.color)));
      if (p.dept) c.push(this.chip('dept', this.tf('chip_for'), p.dept === 'm' ? this.tf('men') : this.tf('women')));
      if (p.shoe) c.push(this.chip('shoe', this.tf('chip_size'), this.tf('in_stock_size', { size: this.tf('eu_size', { size: p.shoe }) }), true));
      if (p.size) c.push(this.chip('size', this.tf('chip_size'), this.tf('in_stock_size', { size: p.size }), true));
      if (p.mySize) c.push(this.chip('mySize', this.tf('chip_size'), this.tf('mine_in_stock'), true));
      if (p.priceMax) c.push(this.chip('priceMax', this.tf('chip_price'), this.tf('under_price', { price: this.money(p.priceMax * 100) }), true));
      if (p.priceMin) c.push(this.chip('priceMin', this.tf('chip_price'), this.tf('over_price', { price: this.money(p.priceMin * 100) }), true));
      if (p.sale) c.push(this.chip('sale', this.tf('chip_only'), this.tf('sale'), true));
      if (p.newOnly) c.push(this.chip('newOnly', this.tf('chip_only'), this.tf('new_in'), true));
      if (p.cheap) c.push(this.chip('cheap', this.tf('chip_sort'), this.tf('lowest_price'), true));
      p.free.forEach((w) => c.push(this.chip('free:' + w, this.tf('chip_text'), w, true)));
      if (p.look) c.push(this.chip('look', this.tf('chip_mode'), this.tf('style_me')));
      let html = c.length ? `<span class="ls-h">${esc(this.tf('understood'))}</span>${c.join('')}` : '';
      if (p.corrected) html += `<span class="ls-fix">${esc(this.tf('showing_instead', { name: p.designer }))} <button type="button" data-act="nofuzzy">${esc(this.tf('search_instead', { query: p.corrected }))}</button></span>`;
      html += '<span class="ls-grow"></span>';
      if (mode === 'results' && count) html += `<a class="ls-cta" href="${esc(this.seeAllUrl)}" data-act="seeall">${esc(this.seeAll(count, true))}</a>`;
      this.el.chips.innerHTML = html;
      this.el.chips.hidden = !c.length && !p.corrected;
    }

    dock(html) {
      this.el.dock.innerHTML = html || '';
      this.el.dock.hidden = !html;
    }

    renderGhostOnly() {
      const raw = this.el.q.value;
      if (!raw.trim()) { this.el.ghost.innerHTML = ''; this.el.suggest.hidden = true; return; }
      const p = this.parse(raw);
      this.P = p;
      if (p.ghost) this.el.ghost.innerHTML = esc(raw.replace(/\s+$/, '')) + '<em>' + esc(p.ghost) + '</em>';
      else this.el.ghost.innerHTML = '';
      if (p.complete) { this.el.suggestText.textContent = p.designer; this.el.suggest.hidden = false; }
      else this.el.suggest.hidden = true;
    }

    async render() {
      const token = ++this.S.req;
      this.S.active = -1;
      const raw = this.el.q.value;
      this.classList.toggle('is-sku', SKU_RE.test(raw));
      this.renderGhostOnly();
      if (!raw.trim()) { this.P = null; this.renderZero(); return; }
      clearTimeout(this.tRemember);
      if (raw.trim().length >= 2) this.tRemember = setTimeout(() => { if (!this.hidden && this.el.q.value === raw) this.remember(); }, 1800);
      const p = this.P;
      const pure = p.designer && !p.cats && !p.color && !p.priceMax && !p.priceMin && !p.sale && !p.newOnly && !this.wantsSize(p) && (!p.dept || p._deptProfile) && !p.free.length && !p.look && !p.cheap;
      const mode = p.look ? 'look' : pure ? 'lens' : 'results';
      this.renderChips(p, 0, mode);
      const body = this.el.body;
      if (!body.querySelector('.ls-card, .ls-skel') || body.dataset.mode !== mode) { body.innerHTML = this.skeleton(4); this.dock(''); }
      else this.tBusy = setTimeout(() => body.classList.add('is-busy'), 120);
      body.dataset.mode = mode;
      try {
        if (mode === 'look') await this.renderLook(p, token);
        else if (mode === 'lens') await this.renderLens(p, token);
        else await this.renderResults(p, token);
      } catch (err) {
        if (token !== this.S.req) return;
        body.innerHTML = `<div class="ls-error"><p class="ls-empty">${esc(this.tf('error_title'))}</p><p class="ls-note">${esc(this.tf('error_note'))}</p><button class="ls-cta" type="button" data-act="retry">${esc(this.tf('try_again'))}</button></div>`;
        this.dock('');
      } finally {
        if (token === this.S.req) { clearTimeout(this.tBusy); body.classList.remove('is-busy'); }
      }
    }

    /* ---------- Zero state ---------- */
    renderZero() {
      this.el.chips.hidden = true;
      this.dock('');
      this.seeAllUrl = '';
      const S = this.S, pr = S.profile, str = this.cfg.str || {};
      const body = this.el.body;
      body.dataset.mode = 'zero';
      const N = this.norm();
      const prompts = this.prompts();
      const T = this._trends && this._trends.dept === pr.dept && this._trends.at === N ? this._trends : null;
      if (!T && !this._trendsNull) this.trends().then((t) => { if ((t || this._trendsNull) && !this.hidden && !this.el.q.value.trim() && this.el.body.dataset.mode === 'zero') this.renderZero(); });
      const override = Array.isArray(this.cfg.trendOverride)
        ? this.cfg.trendOverride.map((x) => (typeof x === 'string' ? { label: x, query: x } : { label: x.label, query: x.query || x.label })).filter((x) => x.label)
        : null;
      const trending = override || (T ? [...T.designers.map((d) => ({ label: d, query: d })), ...T.cats.map((k) => {
        const label = this.catLabel(k);
        const dept = pr.dept === 'w' ? (this.cjk() ? 'women' : this.tf('q_women')) : (this.cjk() ? 'men' : this.tf('q_men'));
        return { label, query: (this.cjk() ? CATS[k].label.toLowerCase() : label.toLowerCase()) + ' ' + dept };
      })] : []);
      const yours = uniq([...S.follows, ...this.top('d', 6, 2)]).slice(0, 6);
      const picks = T ? T.picks : [];
      const viewed = S.viewed.slice(0, 4).map((o) => this.prep(o));
      const sizeTxt = (sys) => sys === 'shoe' ? (pr.shoe ? this.tf('eu_size', { size: pr.shoe }) : this.tf('shoe_size')) : (pr.size || this.tf('clothing_size'));
      const prof = S.editProfile ? `
          <div class="ls-pills" role="group" aria-label="${esc(this.tf('department'))}">
            <button class="ls-pill" type="button" data-act="dept" data-v="m" aria-pressed="${!!pr.deptSet && pr.dept === 'm'}">${esc(this.tf('man'))}</button>
            <button class="ls-pill" type="button" data-act="dept" data-v="w" aria-pressed="${!!pr.deptSet && pr.dept === 'w'}">${esc(this.tf('woman'))}</button>
          </div>
          <label for="ls-pf-shoe-${this.sid}">${esc(this.tf('shoe_size'))} <select id="ls-pf-shoe-${this.sid}" data-pf="shoe"><option value="">${esc(this.tf('choose'))}</option>${SHOE_SIZES.map((x) => `<option${x === pr.shoe ? ' selected' : ''}>${x}</option>`).join('')}</select></label>
          <label for="ls-pf-size-${this.sid}">${esc(this.tf('clothing_size'))} <select id="ls-pf-size-${this.sid}" data-pf="size"><option value="">${esc(this.tf('choose'))}</option>${CLOTH_SIZES.map((x) => `<option${x === pr.size ? ' selected' : ''}>${x}</option>`).join('')}</select></label>
          <button class="ls-link" type="button" data-act="editprofile">${esc(this.tf('done'))}</button>` : `
          <div class="ls-pills">
            <button class="ls-pill${pr.deptSet ? '' : ' ls-pill--dash'}" type="button" data-act="editprofile" aria-pressed="${!!pr.deptSet}">${esc(pr.dept === 'w' ? this.tf('woman') : this.tf('man'))}</button>
            <button class="ls-pill${pr.shoe ? '' : ' ls-pill--dash'}" type="button" data-act="editprofile">${esc(sizeTxt('shoe'))}</button>
            <button class="ls-pill${pr.size ? '' : ' ls-pill--dash'}" type="button" data-act="editprofile">${esc(sizeTxt('cloth'))}</button>
          </div>
          <p>${esc(pr.shoe || pr.size ? this.tf('profile_set') : this.tf('profile_empty'))}${N.signal ? ' ' + esc(this.tf('profile_signals')) : ''}</p>
          ${N.signal || S.recent.length || pr.shoe || pr.size || pr.deptSet ? `<button class="ls-link" type="button" data-act="resetme" style="color:var(--ls-muted)">${esc(this.tf('reset'))}</button>` : ''}`;
      const low = viewed.find((it) => { if (!it.a) return false; const si = this.sizeInfo(it, null); return (si.need && si.n > 0 && si.n <= 2) || it.priceDrop; });
      let nudge = '';
      if (low) {
        const si = this.sizeInfo(low, null);
        const item = low.v + ' ' + low.t;
        const why = low.priceDrop ? this.tf('nudge_price', { item, price: this.money(low.p) }) : this.tf(si.n === 1 ? 'nudge_stock_one' : 'nudge_stock_two', { item, size: si.label });
        nudge = `<div class="ls-nudge"><span class="ls-grow">${esc(why)}</span>${si.need && si.n > 0 ? `<button class="ls-cta" type="button" data-act="qa" data-v="${low.id}">${esc(this.tf('add_size', { size: si.label }))}</button>` : `<a class="ls-cta" href="${esc(low.u)}">${esc(this.tf('view'))}</a>`}</div>`;
      }
      body.innerHTML = `<div class="ls-z${viewed.length || picks.length ? '' : ' ls-z--two'}">
        <div class="ls-z__col">
          <div class="ls-prof ls-z__prof"><p class="ls-h">${esc(str.profile_heading || this.tf('profile_heading'))}</p>${prof}</div>
          ${S.recent.length ? `<div class="ls-z__recent"><div class="ls-headrow"><p class="ls-h">${esc(str.recent_heading || this.tf('recent_heading'))}</p><button class="ls-link" type="button" data-act="clearrecent" style="color:var(--ls-muted)">${esc(this.tf('clear_list'))}</button></div><div class="ls-rows">
            ${S.recent.slice(0, 10).map((r) => `<button class="ls-row" type="button" data-nav data-act="q" data-v="${esc(r)}"><span>${esc(r)}</span><small aria-hidden="true">↖</small></button>`).join('')}
          </div></div>` : ''}
        </div>
        <div class="ls-z__col">
          ${prompts.length ? `<div class="ls-z__asks"><p class="ls-h">${esc(N.signal ? this.tf('suggested_for_you') : (str.try_heading || this.tf('try_heading')))}</p><div class="ls-asks">
            ${prompts.map((t, i) => `<button class="ls-ask" type="button" style="--i:${i}" data-nav data-act="q" data-v="${esc(t.query)}">${esc(t.label)}</button>`).join('')}
          </div></div>` : ''}
          ${trending.length || yours.length ? `<div class="ls-z__trend">
            ${yours.length ? `<p class="ls-h">${esc(this.tf('your_designers'))}</p><div class="ls-tchips ls-scroller" style="margin-bottom:28px">${yours.map((d) => `<button class="ls-tchip ls-tchip--soft" type="button" data-nav data-act="q" data-v="${esc(d)}">${esc(d)}</button>`).join('')}</div>` : ''}
            ${trending.length ? `<p class="ls-h">${esc(str.trend_heading || this.tf('trend_heading'))}</p><div class="ls-tchips ls-scroller">${trending.filter((t) => !yours.includes(t.label)).map((t) => `<button class="ls-tchip" type="button" data-nav data-act="q" data-v="${esc(t.query)}">${esc(t.label)}</button>`).join('')}</div>` : ''}
          </div>` : ''}
        </div>
        ${viewed.length || picks.length ? `<div class="ls-z__col">
          ${viewed.length ? `<div class="ls-z__viewed"><div class="ls-headrow"><p class="ls-h">${esc(str.viewed_heading || this.tf('viewed_heading'))}</p><button class="ls-link" type="button" data-act="clearviewed" style="color:var(--ls-muted)">${esc(this.tf('clear_list'))}</button></div>
            <div class="ls-mini ls-scroller">${viewed.map((it, i) => this.card(it, null, { i, noQa: true })).join('')}</div>${nudge}</div>` : ''}
          ${picks.length ? `<div class="ls-z__picks"><p class="ls-h">${esc(N.signal ? this.tf('picked_for_you') : this.tf('bestsellers_now'))}</p>
            <div class="ls-mini ls-scroller">${picks.map((it, i) => this.card(it, null, { i, noQa: true })).join('')}</div></div>` : ''}
        </div>` : ''}
      </div>`;
    }

    refreshViewed() {
      const list = this.S.viewed.slice(0, 4);
      if (!list.length || this._viewedFresh) return;
      this._viewedFresh = true;
      Promise.all(list.map((o) => fetch(this.cfg.root.replace(/\/$/, '') + '/products/' + o.h + '.js', { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null)))
        .then((res) => {
          let changed = false;
          res.forEach((j, i) => {
            const o = list[i];
            if (!j) return;
            const byId = new Map((j.variants || []).map((v) => [v.id, v]));
            if (j.price < o.p) { o.priceDrop = true; changed = true; }
            o.p = j.price; o.c = j.compare_at_price || 0; o.a = j.available; o.sale = o.c > o.p;
            (o.vs || []).forEach((v) => { const nv = byId.get(v[0]); if (nv) { if (v[1] !== nv.available) changed = true; v[1] = nv.available; if (!nv.available) v[3] = 0; } });
          });
          store.set('viewed', this.S.viewed);
          if (changed && !this.hidden && !this.el.q.value.trim()) this.renderZero();
        });
    }

    /* ---------- Results ---------- */
    async renderResults(p, token) {
      const data = await this.gather(p);
      if (token !== this.S.req) return;
      const pool = data.items;
      if (!p._filterFree && p.free.length) p.ignored = [];
      else p.ignored = p.free.filter((w) => !pool.some((it) => it.hay.includes(w)));
      if (p.ignored.length) p.free = p.free.filter((w) => !p.ignored.includes(w));
      let all = this.rank(pool.filter((it) => this.matches(it, p)), p);
      // Designer typed together with words we can't place: fall back to the designer's own pieces.
      this.seeAllUrl = this.buildSeeAll(p, data, all);
      if (p.sale && /[?&]filter\.p\.product_type=/.test(this.seeAllUrl)) {
        // Show what "See all" opens: the department sale collection also holds pieces of these types
        // that are missing from the category collection (e.g. a coat filed only under sale).
        const r = await this.getPages(this.view(this.seeAllUrl));
        if (token !== this.S.req) return;
        const ids = new Set(all.map((it) => String(it.id)));
        const rest = Object.assign({}, p, { cats: null, free: [], dept: null });
        const extra = ((r && r.items) || []).filter((it) => !ids.has(String(it.id)) && this.matches(it, rest));
        if (extra.length) all = this.rank(all.concat(extra), p);
      }
      this.renderChips(p, all.length, 'results');
      const dCount = {};
      all.forEach((it) => { dCount[it.v] = (dCount[it.v] || 0) + 1; });
      const ds = Object.entries(dCount).sort((a, b) => b[1] - a[1]).slice(0, 4);
      const navHits = (data.navHits || this.navFor(p)).slice(0, 5);
      const types = {};
      if (!navHits.length) all.forEach((it) => { if (it.pt) types[it.pt] = (types[it.pt] || 0) + 1; });
      const tlist = Object.entries(types).sort((a, b) => b[1] - a[1]).slice(0, 5);
      const catHtml = navHits.length
        ? navHits.map((n) => `<a class="ls-row" href="${esc(n.url)}" data-nav><span>${esc(n.t)}</span><small>${esc(n.dept)}</small></a>`).join('')
        : tlist.map(([t, n]) => `<button class="ls-row" type="button" data-nav data-act="q" data-v="${esc(((p.designer ? clean(p.designer) + ' ' : '') + t).toLowerCase())}"><span>${esc(t)}</span><small>${n}</small></button>`).join('');
      const sideNav = `
          ${ds.length > 1 || (ds.length === 1 && !p.designer) ? `<div class="ls-side__nav"><p class="ls-h">${esc(this.tf('designers'))}</p>${ds.map(([d, n]) => `<button class="ls-big" type="button" data-nav data-act="q" data-v="${esc(clean(d))}"><span>${esc(d)}</span><small>${n}</small></button>`).join('')}</div>` : ''}
          ${catHtml ? `<div class="ls-side__nav"><p class="ls-h">${esc(this.tf('categories'))}</p><div class="ls-rows">${catHtml}</div></div>` : ''}`;
      const quick = [
        ...(!p.designer ? ds.slice(0, 3).map(([d]) => `<button class="ls-tchip" type="button" data-act="q" data-v="${esc(clean(d))}">${esc(d)}</button>`) : []),
        ...navHits.slice(0, 4).map((n) => `<a class="ls-tchip ls-tchip--soft" href="${esc(n.url)}">${esc(n.t)} <i style="color:var(--ls-muted)">${esc(n.dept)}</i></a>`)
      ].join('');
      // Close matches: what one less constraint would give
      const near = [];
      const cnt = (k) => pool.filter((it) => this.matches(it, p, k)).length - all.length;
      if (p.priceMax) { const n = cnt('priceMax'); if (n > 0) near.push(['priceMax', this.tf('more_above', { count: n, price: this.money(p.priceMax * 100) })]); }
      if (this.wantsSize(p)) { const n = cnt('size'); if (n > 0) near.push([p.shoe ? 'shoe' : p.size ? 'size' : 'mySize', this.tf('other_sizes_n', { count: n })]); }
      if (p.color) { const n = cnt('color'); if (n > 0) near.push(['color', this.tf('other_colours_n', { count: n })]); }
      if (p.dept) { const n = cnt('dept'); if (n > 0) near.push(['dept', this.tf(p.dept === 'm' ? 'more_for_women' : 'more_for_men', { count: n })]); }
      if (!p.sale) { const n = all.filter((it) => it.sale).length; if (n && n < all.length) near.push(['@sale', this.tf('of_these_sale', { count: n })]); }
      const nearHtml = near.length ? `<div class="ls-near"><p class="ls-h">${esc(this.tf('close_matches'))}</p>${near.map(([k, t]) => `<button type="button" data-act="${k === '@sale' ? 'addword' : 'rm'}" data-v="${k === '@sale' ? 'sale' : k}">${esc(t)}</button>`).join('')}</div>` : '';
      const ignored = p.ignored.length ? `<p class="ls-note">${esc(this.tf('ignored', { words: p.ignored.join('”, “') }))}</p>` : '';
      const alert = this.cfg.klaviyo ? `<div class="ls-dark">
          <p class="ls-h">${esc(all.length ? this.tf('not_quite') : this.tf('nothing_yet'))}</p>
          <h3>${esc((this.wantsSize(p) || p.cats) ? this.tf('tell_when_size', { size: this.sizeLabel(p) }) : this.tf('tell_when'))}</h3>
          <p>${esc(this.tf('save_search_body'))}</p>
          <button class="ls-btn-light" type="button" data-act="savesearch">${esc(this.S.email ? this.tf('save_search') : this.tf('save_search_email'))}</button>
        </div>` : '';
      const side = `<div class="ls-side">${sideNav}${all.length ? nearHtml : ''}${alert}</div>`;
      const body = this.el.body;
      if (!all.length) {
        const keys = ['priceMax', 'size', 'color', 'dept', 'cats', 'designer', 'sale', 'newOnly'].filter((k) => (k === 'size' ? this.wantsSize(p) : p[k]));
        const label = { priceMax: this.tf('any_price'), size: this.tf('any_size'), color: this.tf('any_colour'), dept: this.tf('men_and_women'), cats: this.tf('any_item'), designer: this.tf('any_designer'), sale: this.tf('not_only_sale'), newOnly: this.tf('not_only_new') };
        const keyFor = (k) => (k === 'size' ? (p.shoe ? 'shoe' : p.size ? 'size' : 'mySize') : k);
        const tries = keys.map((k) => [k, pool.filter((it) => this.matches(it, p, k)).length]).filter(([, n]) => n > 0);
        body.innerHTML = `<div class="ls-r">${side}
          <div style="min-width:0">
            <p class="ls-empty">${esc(this.wantsSize(p) ? this.tf('nothing_in_size', { size: this.sizeLabel(p) }) : this.tf('nothing_now'))}</p>
            ${tries.length ? `<p class="ls-h" style="margin-top:24px">${esc(this.tf('try_instead'))}</p><div class="ls-tchips">${tries.map(([k, n]) => `<button class="ls-tchip" type="button" data-nav data-act="rm" data-v="${keyFor(k)}">${esc(label[k])}<i>${n}</i></button>`).join('')}</div>` : ''}
            ${ignored}
            <p class="ls-h" style="margin-top:32px">${esc(this.tf('search_whole_shop'))}</p>
            <a class="ls-cta" href="${esc(this.seeAllUrl)}" data-act="seeall">${esc(this.tf('search_query', { query: this.el.q.value.trim() }))}</a>
          </div>
        </div>`;
        this.dock('');
        this.queueQuery(0, 'results', p);
        return;
      }
      const head = (this.wantsSize(p) ? this.tf('in_stock_in', { size: this.sizeLabel(p) }) : this.S.profile.shoe || this.S.profile.size ? this.tf('your_sizes_first') : this.tf('best_match')) + ' · ' + this.tn('piece', all.length >= 100 ? '100+' : all.length);
      const sortSel = p.cheap ? 'price' : this.S.sort;
      body.innerHTML = `<div class="ls-r">${side}
        <div style="min-width:0">
          ${quick ? `<div class="ls-quick ls-tchips ls-scroller" style="margin-bottom:18px">${quick}</div>` : ''}
          <div class="ls-headrow"><p class="ls-h">${esc(head)}</p>
            <div class="ls-sorts" role="group" aria-label="${esc(this.tf('sort'))}">${[['best', this.tf('sort_best')], ['price', this.tf('sort_price')], ['new', this.tf('sort_new')]].map(([k, t]) => `<button type="button" data-act="sort" data-v="${k}" aria-pressed="${sortSel === k}">${esc(t)}</button>`).join('')}</div>
          </div>
          <div class="ls-cards">${all.slice(0, 12).map((it, i) => this.card(it, p, { i })).join('')}</div>
          ${ignored}
        </div>
      </div>`;
      this.dock(`<a class="ls-cta" href="${esc(this.seeAllUrl)}" data-act="seeall">${esc(this.seeAll(all.length, false))}</a>`);
      this.queueQuery(all.length, 'results', p);
    }

    // The department's own sale collection ("All sale" in the menu): the shortest sale handle for that department.
    saleUrl(dept) {
      const hits = this.nav.filter((n) => /\bsale\b/.test(clean(n.t + ' ' + n.dept)) || /\/collections\/[^/?]*sale/.test(n.url));
      const deptOf = (u) => { const ws = clean((u.split('/collections/')[1] || '').replace(/[-_]/g, ' ')).split(' '); return ws.map((w) => W_DEPT[w]).find(Boolean) || null; };
      const pick = (want) => hits.filter((n) => deptOf(n.url) === want).map((n) => n.url).sort((a, b) => a.length - b.length)[0];
      return (dept && pick(dept)) || this.cfg.sale || pick(null) || this.cfg.collectionsUrl + '/sale';
    }

    buildSeeAll(p, data, items) {
      const params = new URLSearchParams();
      let base;
      if (p.sale) {
        // A collection can't filter on "reduced", so open the sale collection and narrow it to what was shown.
        base = this.saleUrl(p.dept);
        const shown = items || [];
        if (p.cats || p.free.length) uniq(shown.map((it) => it.pt).filter(Boolean)).forEach((t) => params.append('filter.p.product_type', t));
        if (p.designer) uniq(shown.map((it) => it.v).filter(Boolean)).forEach((v) => params.append('filter.p.vendor', v));
      } else if (p.designer && data.brand && data.brand.url) base = data.brand.url;
      else if (p.cats && !p.free.length && data.navHits && data.navHits.length && (!p.dept || data.navHits[0].dk === p.dept)) base = data.navHits[0].url;
      else if (!this.plainWords(p) && (p.color || p.priceMax || p.priceMin)) {
        // Only a colour and/or price ("pink", "black under 500"): Shopify search can't match the colour
        // metafield, so open the department (or whole shop) collection with the filters applied.
        base = (p.dept && (this.cfg.deptUrl || {})[p.dept]) || this.cfg.collectionsUrl + '/all';
      } else {
        base = this.cfg.searchUrl;
        params.set('q', this.plainWords(p) || this.el.q.value.trim());
        params.set('type', 'product');
        params.set('options[prefix]', 'last');
        params.set('options[unavailable_products]', 'hide');
      }
      if (p.priceMax) params.set('filter.v.price.lte', p.priceMax);
      if (p.priceMin) params.set('filter.v.price.gte', p.priceMin);
      if (p.color && this.cfg.colorParam) params.set(this.cfg.colorParam, this.colorValue(p.color));
      if (base !== this.cfg.searchUrl) params.set('filter.v.availability', '1');
      const qs = params.toString();
      return base + (qs ? (base.includes('?') ? '&' : '?') + qs : '');
    }

    /* ---------- Designer lens ---------- */
    async renderLens(p, token) {
      const b = await this.brand(p.designer);
      if (token !== this.S.req) return;
      const d = p.designer;
      const items = (b.items || []).filter((it) => clean(it.v) === clean(d) || clean(it.v).startsWith(clean(d) + ' ') || b.brand);
      if (!items.length) { p.designer = d; return this.renderResults(Object.assign(p, { free: [clean(d)], designer: undefined }), token); }
      this.seeAllUrl = b.url || (this.cfg.collectionsUrl + '/vendors?q=' + encodeURIComponent(d));
      // Men first, then unisex, women, kids (stable, so each tab keeps its own order within a group).
      const isKid = (it) => (it.cl || []).some((h) => /^(kid|kinder|child|baby|junior)/.test(h)) || (it.tg || []).some((t) => /^(kids?|kinder|children|baby|junior)$/i.test(t));
      const grp = (it) => (isKid(it) ? 3 : it.dept === 'm' ? 0 : !it.dept ? 1 : 2);
      const menFirst = (arr) => arr.map((it, i) => [it, i]).sort((x, y) => grp(x[0]) - grp(y[0]) || x[1] - y[1]).map((x) => x[0]);
      const inDept = (it) => !p.dept || (!isKid(it) && (!it.dept || it.dept === p.dept));
      const avail = menFirst((b.availItems && b.availItems.length ? b.availItems : items.filter((it) => it.a)).filter(inDept));
      const total = !p.dept ? (b.availCount != null ? b.availCount : avail.length)
        : (b.availItems || []).length >= 100 ? Math.max(avail.length, 100) : avail.length;
      const tab = this.S.lensTab;
      const SHOW = 8;
      let list = tab === 'new' ? menFirst(avail.slice().sort((x, y) => y.n - x.n))
        : tab === 'size' ? avail.filter((it) => { const si = this.sizeInfo(it, p); return !si.need || !si.want || si.n > 0; })
        : avail.slice();
      list = list.slice(0, SHOW);
      if (list.length < SHOW && tab !== 'size') list = list.concat(avail.filter((it) => !list.includes(it)).slice(0, SHOW - list.length));
      const dOrd = (dk) => (dk === 'm' ? 0 : dk === 'w' ? 1 : 2);
      const depts = (this.dmap.get(clean(d)) || []).slice().sort((x, y) => dOrd(x.dk) - dOrd(y.dk));
      const deptCount = (dk) => avail.filter((it) => it.dept === dk || !it.dept).length;
      const sale = avail.filter((it) => it.sale).length;
      const types = {};
      items.forEach((it) => { if (it.pt) types[it.pt] = (types[it.pt] || 0) + 1; });
      const sim = (this.similar[clean(d)] || []).slice(0, 5);
      const following = this.S.follows.includes(d);
      const blurb = b.desc || '';
      // Background: a random full-look photo from the 10 most recent men/women pieces (no kids), fixed per designer while open.
      if (!this._lensImg || this._lensImg.d !== d) {
        // Second product photo = the full look; pieces without one are skipped.
        const pool = (avail.length ? avail : items).filter((it) => !isKid(it)).sort((x, y) => y.n - x.n).slice(0, 10).filter((it) => it.img2);
        const pick = pool.length ? pool[Math.floor(Math.random() * pool.length)] : null;
        this._lensImg = { d, img: pick ? pick.img2 : b.img || null };
      }
      const heroImg = this._lensImg.img;
      const rows = depts.length
        ? depts.map((x) => `<a href="${esc(x.url)}" data-nav data-dcount="${esc(x.url)}"><span>${esc(x.dept)}</span><small>… →</small></a>`).join('')
        : ['m', 'w'].filter((k) => deptCount(k)).map((k) => `<button type="button" data-nav data-act="q" data-v="${esc(clean(d) + ' ' + (k === 'm' ? this.tf('q_men') : this.tf('q_women')))}"><span>${esc(k === 'm' ? this.tf('men') : this.tf('women'))}</span><small>${esc(this.pieces(deptCount(k)))} →</small></button>`).join('');
      const saleRow = sale ? `<button class="is-sale" type="button" data-nav data-act="q" data-v="${esc(clean(d) + ' sale')}"><span>${esc(this.tf('sale'))}</span><small>${esc(this.pieces(sale))} →</small></button>` : '';
      const tabs = [['new', this.tf('new_in')], ['size', this.S.profile.shoe || this.S.profile.size ? this.tf('in_my_size') : this.tf('in_stock')], ['best', this.tf('bestsellers')]];
      this.el.body.innerHTML = `<div class="ls-lens">
        <section class="ls-lens__dark" aria-label="${esc(d)}">
          ${heroImg ? `<img class="ls-lens__img" ${this.srcset(heroImg)} sizes="440px" alt="" loading="lazy">` : `<span class="ls-lens__glyph" aria-hidden="true">${esc(d.trim()[0] || '')}</span>`}
          <p class="ls-h">${esc(this.pieces(total))}</p>
          <h2 class="ls-lens__name">${esc(d)}</h2>
          ${blurb ? `<p class="ls-lens__blurb">${esc(blurb)}</p>` : ''}
          <span class="ls-grow"></span>
          <div class="ls-lens__rows">${rows}${saleRow}</div>
          <button class="ls-follow" type="button" data-act="follow" data-v="${esc(d)}" aria-pressed="${following}">${following ? esc(this.tf('following')) : esc(this.tf('follow', { name: d }))}</button>
        </section>
        <div class="ls-lens__right">
          <div class="ls-lens__top">
            <div class="ls-segs ls-scroller" role="group" aria-label="${esc(this.tf('show'))}">${tabs.map(([k, t]) => `<button class="ls-seg" type="button" data-act="lens" data-v="${k}" aria-pressed="${tab === k}">${esc(t)}</button>`).join('')}</div>
            <a class="ls-cta" href="${esc(this.seeAllUrl)}" data-act="seeall">${esc(this.tf('shop_all_arrow', { name: d }))}</a>
          </div>
          ${list.length ? `<div class="ls-cards">${list.map((it, i) => this.card(it, p, { i })).join('')}</div>` : `<p class="ls-empty">${esc(this.tf('nothing_in_size', { size: this.sizeLabel(p) }))}</p>`}
          <div class="ls-two">
            ${Object.keys(types).length > 1 ? `<div><p class="ls-h">${esc(this.tf('shop_by', { name: d }))}</p><div class="ls-tchips">${Object.entries(types).sort((a, b2) => b2[1] - a[1]).slice(0, 8).map(([t, n]) => `<button class="ls-tchip" type="button" data-nav data-act="q" data-v="${esc((clean(d) + ' ' + t).toLowerCase())}">${esc(t)}<i style="color:var(--ls-muted)">${n}</i></button>`).join('')}</div></div>` : ''}
            ${sim.length ? `<div><p class="ls-h">${esc(this.tf('if_you_love', { name: d }))}</p><div class="ls-tchips">${sim.map((x) => `<button class="ls-tchip ls-tchip--soft" type="button" data-nav data-act="q" data-v="${esc(x)}">${esc(x)}</button>`).join('')}</div></div>` : ''}
          </div>
        </div>
      </div>`;
      this.dock(`<a class="ls-cta" href="${esc(this.seeAllUrl)}" data-act="seeall">${esc(this.tf('shop_all', { name: d }))}</a>`);
      this.queueQuery(total, 'designer', p);
      // Real per-department counts: the department collection filtered on this designer, in stock only.
      this.el.body.querySelectorAll('[data-dcount]').forEach((row) => {
        this.get(this.view(row.dataset.dcount, '&filter.v.availability=1')).then((r) => {
          if (token !== this.S.req || !row.isConnected) return;
          const n = r ? r.count : null;
          if (n === 0) { row.remove(); return; }
          row.querySelector('small').textContent = (n == null ? this.tf('shop') : this.pieces(n)) + ' →';
        });
      });
    }

    /* ---------- Style me ---------- */
    async lookFor(p) {
      const dept = p.dept || this.S.profile.dept;
      const urls = (this.cfg.look || {})[dept] || [];
      const keys = ['outerwear', 'top', 'bottom', 'shoes'];
      const names = keys.map((k) => this.tf('slot_' + k));
      const res = await Promise.all(urls.map((u) => (u ? this.get(this.view(u)) : null)));
      const SHARP = /tailor|wool|leather|coat|blazer|trouser|boot|derby|loafer|shirt|cashmere/i;
      const EASY = /oversized|hoodie|sweat|jean|denim|cargo|knit|jumper|sneaker|runner|tee|t-shirt|relaxed/i;
      return res.map((r, idx) => {
        if (!r || !(r.items || []).length) return null;
        let c = r.items.filter((it) => it.a);
        const narrow = (f) => { const n = c.filter(f); if (n.length) c = n; };
        if (p.designer) narrow((it) => clean(it.v) === clean(p.designer));
        if (p.color) narrow((it) => this.colorOk(it, p.color));
        narrow((it) => { const si = this.sizeInfo(it, p); return !si.need || !si.want || si.n > 0; });
        if (p.priceMax) narrow((it) => it.p <= p.priceMax * 100 / 3);
        const sc = (it) => {
          const t = it.t + ' ' + it.pt + ' ' + (it.tg || []).join(' ');
          if (this.S.tone === 'sharper') return (SHARP.test(t) ? 3 : 0) + it.p / 200000;
          if (this.S.tone === 'relaxed') return (EASY.test(t) ? 3 : 0) - it.p / 400000;
          if (this.S.tone === 'budget') return -it.p;
          return (it.isNew ? 1 : 0) + (p.occasion === 'office' && SHARP.test(t) ? 2 : 0) + (p.occasion === 'weekend' && EASY.test(t) ? 2 : 0);
        };
        c = c.map((it, i) => [it, i]).sort((a, b) => sc(b[0]) - sc(a[0]) || a[1] - b[1]).map((x) => x[0]);
        if (!c.length) return null;
        const i = (this.S.lookIdx[keys[idx]] || 0) % c.length;
        return { slot: names[idx], slotId: keys[idx], item: c[i], count: `${i + 1}/${c.length}` };
      }).filter(Boolean);
    }

    async renderLook(p, token) {
      const slots = await this.lookFor(p);
      if (token !== this.S.req) return;
      if (slots.length < 2) { this.S.noLook = true; return this.render(); }
      this.lookSlots = slots;
      this.seeAllUrl = '';
      const occ = OCCASIONS[p.occasion];
      const [a, b] = occ ? [this.tf('occ_' + p.occasion + '_a'), this.tf('occ_' + p.occasion + '_b')] : p.color === 'black' ? [this.tf('look_black_a'), this.tf('look_black_b')] : [this.tf('look_fallback_a'), this.tf('look_fallback_b')];
      const total = slots.reduce((s, x) => s + x.item.p, 0);
      const dept = p.dept || this.S.profile.dept;
      const deptName = dept === 'w' ? this.tf('women') : this.tf('men');
      const sizes = (x) => { const si = this.sizeInfo(x.item, p); return si.need ? (si.want ? si.label : this.tf('pick_size')) : ''; };
      const missing = slots.some((x) => { const si = this.sizeInfo(x.item, p); return si.need && !si.want; });
      const others = Object.keys(OCCASIONS).filter((k) => k !== p.occasion).slice(0, 3);
      this.el.body.innerHTML = `
        <div class="ls-lk__head">
          <div><p class="ls-lk__k">${esc(this.S.profile.shoe || this.S.profile.size ? this.tf('style_me_kicker_sizes', { dept: deptName }) : this.tf('style_me_kicker', { dept: deptName }))}</p><h2 class="ls-lk__title">${esc(a)}<em>${esc(b)}</em></h2></div>
          <span class="ls-grow"></span>
          <div class="ls-segs" role="group" aria-label="${esc(this.tf('department'))}">
            <button class="ls-seg" type="button" data-act="dept" data-v="m" aria-pressed="${dept === 'm'}">${esc(this.tf('men'))}</button>
            <button class="ls-seg" type="button" data-act="dept" data-v="w" aria-pressed="${dept === 'w'}">${esc(this.tf('women'))}</button>
          </div>
          <div class="ls-tchips ls-scroller" role="group" aria-label="${esc(this.tf('adjust_look'))}">
            ${[['sharper', this.tf('sharper')], ['relaxed', this.tf('more_relaxed')], ['budget', this.tf('lower_budget')]].map(([k, t]) => `<button class="ls-tchip" type="button" data-act="tone" data-v="${k}" aria-pressed="${this.S.tone === k}">${esc(t)}</button>`).join('')}
          </div>
        </div>
        <div class="ls-lk ls-scroller">
          ${slots.map((x, i) => this.card(x.item, p, { i, slot: x.slot, swap: true, count: x.count, noQa: false })).join('')}
          <div class="ls-sum">
            <p class="ls-h">${esc(this.tf('complete_look'))}</p>
            <span class="ls-sum__total">${this.money(total)}</span>
            <div class="ls-sum__lines">${slots.map((x) => `<span><span>${esc(x.slot)}${sizes(x) ? ' · ' + esc(sizes(x)) : ''}</span><span>${this.money(x.item.p)}</span></span>`).join('')}</div>
            <p>${esc(missing ? this.tf('look_set_sizes') : this.tf('look_swap'))}</p>
            <span class="ls-grow"></span>
            <button class="ls-btn-light" type="button" data-act="${missing ? 'editsizes' : 'addlook'}">${esc(missing ? this.tf('set_my_sizes') : this.tf('add_look'))}</button>
          </div>
        </div>
        <div class="ls-more">
          <p class="ls-h">${esc(this.tf('other_moods'))}</p>
          ${others.map((k) => `<button class="ls-ml" type="button" data-nav data-act="q" data-v="look for ${esc(k)}">${esc(this.tf('occ_' + k + '_a') + this.tf('occ_' + k + '_b'))}</button>`).join('')}
          <span class="ls-grow"></span>
          <button class="ls-link" type="button" data-act="nolook">${esc(this.tf('show_pieces'))}</button>
        </div>`;
      this.dock(`<span class="ls-dockbar__sum">${esc(this.tf('the_look'))}<b>${this.money(total)}</b></span><button class="ls-cta" type="button" data-act="${missing ? 'editsizes' : 'addlook'}">${esc(missing ? this.tf('set_my_sizes') : this.tf('add_all', { count: slots.length }))}</button>`);
      this.queueQuery(slots.length, 'look', p);
    }

    /* ============================================================
       Actions
       ============================================================ */
    onClick(e) {
      const t = e.target.closest('[data-act]');
      if (!t || !this.contains(t)) return;
      const act = t.dataset.act, v = t.dataset.v;
      if (REFINE[act]) {
        this.flushQuery();
        this.track('labels_search_refine', { refine_type: REFINE[act], refine_value: v || '', search_term: this.el.q.value.trim() });
      }
      const S = this.S;
      switch (act) {
        case 'close': e.preventDefault(); return this.close();
        case 'clear': return this.setQuery('');
        case 'complete': return this.complete();
        case 'retry': this.cache.clear(); return this.render();
        case 'q': this._src = this.srcOf(t); this.setQuery(v); this.remember(); return;
        case 'rm': S.removed.add(v); return this.render();
        case 'addword': this.el.q.value = this.el.q.value.trim() + ' ' + v; return this.render();
        case 'nofuzzy': S.noFuzzy = true; return this.render();
        case 'nolook': S.noLook = true; return this.render();
        case 'sort': S.sort = v; return this.render();
        case 'lens': S.lensTab = v; return this.render();
        case 'tone': S.tone = S.tone === v ? null : v; S.lookIdx = {}; return this.render();
        case 'swap': S.lookIdx[v] = (S.lookIdx[v] || 0) + 1; return this.render();
        case 'dept': S.profile.dept = v; S.profile.deptSet = true; store.set('profile', S.profile); S.lookIdx = {}; return this.render();
        case 'editprofile': S.editProfile = !S.editProfile; return this.renderZero();
        case 'editsizes': S.editProfile = true; this.setQuery(''); return;
        case 'clearviewed': S.viewed = []; store.set('viewed', []); return this.renderZero();
        case 'clearrecent': S.recent = []; store.set('recent', []); return this.renderZero();
        case 'follow': return this.follow(v);
        case 'savesearch': return this.withEmail('search', { query: this.el.q.value.trim() });
        case 'mailcancel': return this.mailClose();
        case 'bag': return this.openBag();
        case 'open': { const c = t.closest('[data-pid]'); if (c) { this.learnItem(this.items.get(c.dataset.pid), 1.5); this.trackSelect(c); } this.remember(); return; }
        case 'seeall': this.remember(); this.trackViewAll(); return;
        case 'resetme': return this.resetMe();
        case 'qa': return this.quickAdd(v, t);
        case 'sizes': return this.openSizes(v, t);
        case 'sizesclose': return this.closeSizes();
        case 'addv': return this.addVariant(t.dataset.variant, this.items.get(v), t.dataset.size, t);
        case 'notifyv': return this.withEmail('stock', { variant: t.dataset.variant, item: this.items.get(v), size: t.dataset.size });
        case 'addlook': return this.addLook(t);
      }
    }

    quickAdd(id, btn) {
      const it = this.items.get(String(id));
      if (!it) return;
      const si = this.sizeInfo(it, this.P);
      if (si.need && !(si.want && si.n > 0)) return this.openSizes(id, btn);
      if (!si.v) return this.openSizes(id, btn);
      this.addVariant(si.v[0], it, si.need ? si.want : '', btn);
    }

    openSizes(id, btn) {
      const it = this.items.get(String(id));
      const panel = btn.closest('.ls-card').querySelector('[data-sizes]');
      this.closeSizes(panel);
      if (!it || it.si < 0) {
        if (it && !it.a && this.cfg.klaviyo && it.vs && it.vs[0]) return this.withEmail('stock', { variant: it.vs[0][0], item: it, size: '' });
        return;
      }
      const mine = it.sys === 'shoe' ? this.S.profile.shoe : this.S.profile.size;
      const rows = it.sizes.map((sz) => {
        const vs = it.vs.filter((v) => v[2][it.si] === sz);
        const pref = (this.P && this.P.color && it.ci >= 0) ? vs.find((v) => v[1] && COLORS[this.P.color].split(' ').some((w) => clean(v[2][it.ci]).includes(w))) : null;
        const v = pref || vs.find((x) => x[1]) || vs[0];
        const out = !v || !v[1];
        const isMine = mine && this.nsz(sz) === this.nsz(mine);
        if (out) return this.cfg.klaviyo && v
          ? `<button class="ls-sz is-out can-notify${isMine ? ' is-mine' : ''}" type="button" data-act="notifyv" data-v="${it.id}" data-variant="${v[0]}" data-size="${esc(sz)}" aria-label="${esc(this.tf('sold_out_notify', { size: sz }))}">${esc(sz)}</button>`
          : `<button class="ls-sz is-out${isMine ? ' is-mine' : ''}" type="button" disabled aria-label="${esc(this.tf('sold_out_size', { size: sz }))}">${esc(sz)}</button>`;
        return `<button class="ls-sz${isMine ? ' is-mine' : ''}" type="button" data-act="addv" data-v="${it.id}" data-variant="${v[0]}" data-size="${esc(sz)}">${esc(sz)}</button>`;
      }).join('');
      panel.innerHTML = `<div class="ls-sizes__top"><span>${esc(it.a ? this.tf('select_size_title') : this.tf('notify_in'))}</span><button type="button" data-act="sizesclose" aria-label="${esc(this.tf('close_sizes'))}">×</button></div><div class="ls-sizes__list">${rows}</div>`;
      panel.hidden = false;
      const first = panel.querySelector('.ls-sz.is-mine:not([disabled]), .ls-sz:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    }

    closeSizes(except) {
      this.querySelectorAll('[data-sizes]:not([hidden])').forEach((p) => { if (p !== except) { p.hidden = true; p.innerHTML = ''; } });
    }

    async addVariant(variantId, it, size, btn) {
      if (!variantId) return;
      const card = btn && btn.closest ? btn.closest('.ls-card') : null;
      const qa = btn && (card?.querySelector('.ls-qa') || btn);
      if (qa) qa.classList.add('is-busy');
      const ctx = this.attribute(it, card);
      try {
        const line = { id: Number(variantId), quantity: 1 };
        if (ctx.prop) line.properties = { _ls_search: ctx.prop };
        const r = await fetch(this.cfg.cartAddUrl + '.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [line] })
        });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || this.tf('add_fail_short'));
        // Learn the shopper's size the first time they pick one.
        let learned = '';
        if (size && it && it.sys) {
          const k = it.sys === 'shoe' ? 'shoe' : 'size';
          if (!this.S.profile[k]) { this.S.profile[k] = size.replace(/^(EU|IT|FR)\s*/i, ''); store.set('profile', this.S.profile); learned = k === 'shoe' ? this.tf('eu_size', { size: this.S.profile[k] }) : this.S.profile[k]; }
        }
        this.closeSizes();
        this.learnItem(it, 3);
        this.trackAdd(it, variantId, btn && btn.dataset.act === 'addv' ? 'size_panel' : 'quick_add', ctx);
        await this.syncCart();
        const item = it ? it.v + ' ' + it.t : this.tf('piece_word');
        this.toast((size ? this.tf('added_size', { item, size }) : this.tf('added', { item })) + (learned ? this.tf('saved_size', { size: learned }) : ''), this.tf('view_bag'), () => this.openBag());
      } catch (err) {
        this.toast(err.message || this.tf('add_fail'));
      } finally {
        if (qa) qa.classList.remove('is-busy');
      }
    }

    async addLook(btn) {
      const items = [];
      const added = [];
      const cards = [...this.el.body.querySelectorAll('.ls-lk .ls-card')];
      (this.lookSlots || []).forEach((x, i) => {
        const si = this.sizeInfo(x.item, this.P);
        if (!si.v || (si.need && !(si.n > 0))) return;
        const ctx = this.attribute(x.item, cards[i] || null);
        const line = { id: si.v[0], quantity: 1 };
        if (ctx.prop) line.properties = { _ls_search: ctx.prop };
        items.push(line);
        added.push([x.item, si.v[0], ctx]);
      });
      if (!items.length) return;
      btn.disabled = true;
      try {
        const r = await fetch(this.cfg.cartAddUrl + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || this.tf('look_fail'));
        (this.lookSlots || []).forEach((x) => this.learnItem(x.item, 2));
        added.forEach(([item, variantId, ctx]) => this.trackAdd(item, variantId, 'look', ctx));
        await this.syncCart();
        const skipped = (this.lookSlots || []).length - items.length;
        this.toast(this.tf('added_look', { count: items.length }) + (skipped ? this.tf('added_look_skip', { count: skipped }) : ''), this.tf('view_bag'), () => this.openBag());
      } catch (err) { this.toast(err.message); } finally { btn.disabled = false; }
    }

    async syncCart() {
      try {
        const cart = await fetch(this.cfg.cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((r) => r.json());
        this.setCount(cart.item_count, true);
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: this.id, data: { itemCount: cart.item_count, source: 'labels-search' } } }));
      } catch (_) {}
    }

    setCount(n, bump) {
      this.el.counts.forEach((c) => { c.textContent = n; c.hidden = !n; if (bump) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); } });
    }

    openBag() {
      this.close();
      setTimeout(() => {
        const mm = document.getElementById('labels-mm');
        const links = mm ? [...mm.querySelectorAll('[data-mm-proxy="cart"]')] : [];
        const a = links.find((x) => x.offsetParent !== null) || links[0];
        if (a) a.click(); else window.location.href = this.cfg.cartUrl;
      }, 280);
    }

    follow(d) {
      const S = this.S;
      if (S.follows.includes(d)) {
        S.follows = S.follows.filter((x) => x !== d); store.set('follows', S.follows);
        this.track('labels_search_engage', { engage_type: 'unfollow', designer: d, search_term: this.el.q.value.trim() });
        this.toast(this.tf('unfollow', { name: d })); return this.render();
      }
      const done = () => { S.follows = [...S.follows, d]; store.set('follows', S.follows); this.bump('d', d, 3); this.render(); };
      if (this.cfg.klaviyo) return this.withEmail('follow', { designer: d }, done);
      done();
      this.track('labels_search_engage', { engage_type: 'follow', designer: d, search_term: this.el.q.value.trim() });
      this.toast(this.tf('following_toast', { name: d }));
    }

    /* ---------- Email-based signals (Klaviyo) ---------- */
    withEmail(type, data, after) {
      this.mailCtx = { type, data, after };
      if (this.S.email) return this.mailSubmit(this.S.email);
      const piece = data.item ? data.item.v + ' ' + data.item.t : this.tf('piece_word');
      const copy = {
        stock: [data.size ? this.tf('mail_stock_title_size', { size: data.size }) : this.tf('mail_stock_title'), this.tf('mail_stock_body', { item: piece })],
        search: [this.tf('mail_search_title'), this.tf('mail_search_body')],
        follow: [this.tf('mail_follow_title', { name: data.designer }), this.tf('mail_follow_body')]
      }[type];
      this.el.mailTitle.textContent = copy[0];
      this.el.mailText.textContent = copy[1];
      this.el.mail.hidden = false;
      this.el.mailInput.value = '';
      this.el.mailInput.focus();
    }

    mailClose() { this.el.mail.hidden = true; this.mailCtx = null; }

    async mailSubmit(known) {
      const ctx = this.mailCtx;
      if (!ctx) return;
      const email = (known || this.el.mailInput.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { this.el.mailInput.focus(); return; }
      this.S.email = email; store.set('email', email);
      this.el.mail.hidden = true;
      const key = this.cfg.klaviyo;
      const post = (path, body) => fetch(`https://a.klaviyo.com/client/${path}/?company_id=${encodeURIComponent(key)}`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body)
      });
      const profile = { data: { type: 'profile', attributes: { email } } };
      const event = (name, properties) => post('events', { data: { type: 'event', attributes: { properties, metric: { data: { type: 'metric', attributes: { name } } }, profile } } });
      let ok = true;
      try {
        let r;
        if (ctx.type === 'stock') {
          r = await post('back-in-stock-subscriptions', { data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + ctx.data.variant } } } } });
        } else if (ctx.type === 'search') {
          const p = this.P || {};
          r = await event('Saved Search', { query: ctx.data.query, designer: p.designer || null, category: p.cats ? p.cats.label : null, colour: p.color || null, size: p.shoe || p.size || null, price_max: p.priceMax || null, url: this.seeAllUrl || null });
        } else if (ctx.type === 'follow') {
          r = await event('Followed Designer', { designer: ctx.data.designer });
        }
        ok = !r || r.ok || r.status === 202;
      } catch (_) { ok = false; }
      document.dispatchEvent(new CustomEvent('labels-search:signal', { detail: Object.assign({ type: ctx.type, email }, ctx.data) }));
      if (!ok) { this.toast(this.tf('mail_fail')); return; }
      this.track('labels_search_engage', {
        engage_type: { stock: 'stock_alert', search: 'save_search', follow: 'follow' }[ctx.type] || ctx.type,
        designer: ctx.data.designer || '',
        product_id: ctx.data.item ? String(ctx.data.item.id) : '',
        search_term: this.el.q.value.trim()
      });
      if (ctx.after) ctx.after();
      this.toast({ stock: this.tf('toast_stock'), search: this.tf('toast_search'), follow: this.tf('toast_follow', { name: ctx.data.designer }) }[ctx.type]);
      this.mailCtx = null;
    }

    toast(msg, actionLabel, action) {
      const t = this.el.toast;
      t.innerHTML = `<span>${esc(msg)}</span>${actionLabel ? `<button type="button">${esc(actionLabel)}</button>` : ''}`;
      if (actionLabel) t.querySelector('button').addEventListener('click', () => { t.hidden = true; action(); });
      t.hidden = false;
      t.style.animation = 'none'; void t.offsetWidth; t.style.animation = '';
      clearTimeout(this.tToast);
      this.tToast = setTimeout(() => (t.hidden = true), actionLabel ? 5200 : 3400);
    }

    /* ---------- Analytics (labels_search_* custom events, see assets/labels-search-analytics.js) ---------- */
    ana() { return window.LabelsSearchAnalytics || null; }
    track(name, data) { try { const A = this.ana(); if (A) A.track(name, data); } catch (_) {} }
    currency() { return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''; }

    srcOf(t) {
      if (t.closest('.ls-z__recent')) return 'recent';
      if (t.classList.contains('ls-ask')) return 'suggestion';
      if (t.closest('.ls-z__trend')) return 'trending';
      return 'chip';
    }

    // Reported once per term per overlay session, after the term has rested for a second.
    queueQuery(count, mode, p) {
      clearTimeout(this.tQuery);
      const term = this.el.q.value.trim();
      if (!term) return;
      this._lastCount = count;
      this._pendingQ = { term, count, mode, corrected: !!(p && p.corrected), src: this._src || 'typed' };
      this.tQuery = setTimeout(() => this.flushQuery(), 1000);
    }

    flushQuery() {
      clearTimeout(this.tQuery);
      const q = this._pendingQ;
      this._pendingQ = null;
      const A = this.ana();
      if (!q || !A) return;
      const key = A.normTerm(q.term);
      if (!key || this._sentQ.has(key)) return;
      this._sentQ.add(key);
      this._lastTerm = q.term;
      this.track('labels_search_query', { search_term: q.term, result_count: q.count, search_mode: q.mode, search_source: q.src, corrected: q.corrected });
      if (!q.count) this.track('labels_search_no_results', { search_term: q.term, search_source: q.src });
    }

    listOf(card) {
      if (card && card.closest('.ls-z__viewed')) return 'viewed';
      if (card && card.closest('.ls-z__picks')) return 'picks';
      return { lens: 'designer', look: 'look', zero: 'viewed' }[this.el.body.dataset.mode] || 'results';
    }

    cardPos(card) {
      const scope = card && card.closest('.ls-cards, .ls-mini, .ls-lk');
      return scope ? [...scope.querySelectorAll('.ls-card')].indexOf(card) + 1 : 0;
    }

    // Remembers the search that led to this product (24h) and returns the _ls_search value.
    attribute(it, card) {
      const term = this.el.q.value.trim();
      const list = this.listOf(card);
      const pos = this.cardPos(card);
      const A = this.ana();
      if (!A || !it) return { term, list, pos, prop: null };
      A.remember(it.id, { q: term || '[' + list + ']', pos });
      return { term, list, pos, prop: A.propertyFor(it.id) };
    }

    trackSelect(card) {
      this.flushQuery();
      const it = this.items.get(card.dataset.pid);
      const ctx = this.attribute(it || { id: card.dataset.pid }, card);
      if (this._sess) this._sess.select = true;
      this.track('labels_search_select_item', {
        search_term: ctx.term, product_id: String(card.dataset.pid), product_handle: it ? it.h : '',
        position: ctx.pos, item_list: ctx.list, price: it ? it.p / 100 : null, currency: this.currency()
      });
    }

    trackAdd(it, variantId, source, ctx) {
      this.flushQuery();
      if (this._sess) this._sess.add = true;
      this.track('labels_search_add_to_cart', {
        search_term: ctx.term, product_id: it ? String(it.id) : '', variant_id: String(variantId), quantity: 1,
        price: it ? it.p / 100 : null, currency: this.currency(), add_source: source, position: ctx.pos, item_list: ctx.list
      });
    }

    trackViewAll() {
      const count = this._pendingQ ? this._pendingQ.count : this._lastCount;
      this.flushQuery();
      this.track('labels_search_view_all', { search_term: this.el.q.value.trim(), result_count: count == null ? null : count });
    }

    /* ---------- Keyboard list navigation ---------- */
    navItems() { return [...this.el.body.querySelectorAll('[data-nav]')].filter((x) => x.offsetParent !== null); }
    setActive(i, scroll) {
      const items = this.navItems();
      items.forEach((x) => x.classList.remove('is-active'));
      if (!items.length) { this.S.active = -1; return; }
      this.S.active = (i + items.length) % items.length;
      const el = items[this.S.active];
      el.classList.add('is-active');
      if (scroll) el.scrollIntoView({ block: 'nearest' });
    }
    activate(el) {
      const target = el.matches('[data-act], a[href]') ? el : el.querySelector('.ls-card__txt, [data-act]');
      if (target) target.click();
    }
  }

  customElements.define('labels-search', LabelsSearch);
})();
